<template>
  <div class="row bg-white">
    <div class="col-12">
      <div class="row gy-2">
        <div class="col-12">
          <!-- Country filter -->
          <div class="dash-filterbar">
            <NSelect v-model:value="FILTERS.COUNTRY" :disabled="isLoading" :options="COUNTRY_OPTS"
              :theme-overrides="inputTheme" filterable clearable placeholder="Select countries to view"
              :input-props="{ autocomplete: Math.random() }" class="dash-filterbar__select" size="small" />
            <div v-if="activeTab == 'Trade Flow'" class="dash-filterbar__date">
              <span class="dash-filterbar__label">Select Year</span>
              <NDatePicker v-model:value="searchYear" type="year" :is-date-disabled="isTradeFlowYearOutOfRange" :theme-overrides="inputTheme"
                :input-props="{ autocomplete: randomId }" class="dash-filterbar__datepicker" size="small" />
            </div>
            <div v-else class="dash-filterbar__date">
              <span class="dash-filterbar__label">Start</span>
              <NDatePicker v-model:value="yearsView[0]" type="year" clearable :is-date-disabled="disableOutOfRange" :theme-overrides="inputTheme"
                :input-props="{ autocomplete: randomId }" class="dash-filterbar__datepicker" size="small" />
              <span class="dash-filterbar__label">End</span>
              <NDatePicker v-model:value="yearsView[1]" type="year" clearable :is-date-disabled="disableOutOfRange" :theme-overrides="inputTheme"
                :input-props="{ autocomplete: randomId }" class="dash-filterbar__datepicker" size="small" />
            </div>
            <NButton size="small" :disabled="isDisabled" @click="getTableData()" color="#213ce5"
              style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent;"
              @mouseenter="e => e.currentTarget.style.border = '1px solid #00aeef'"
              @mouseleave="e => e.currentTarget.style.border = '1px solid transparent'">
              Search
            </NButton>
          </div>

          <!-- Action row -->
          <div class="dash-actions">
            <NTabs v-model:value="activeTab" type="segment" size="small" class="country-tabs"
              @update:value="getTableData">
              <NTabPane tab="Supply" name="Supply">
              </NTabPane>
              <NTabPane tab="Trade" name="Trade">
              </NTabPane>
              <NTabPane tab="Trade flow" name="Trade Flow">
              </NTabPane>
            </NTabs>

            <NSelect v-model:value="FILTERS.ELEMENT" :disabled="isLoading" :options="ELEMENT_OPTS"
              :theme-overrides="inputTheme" filterable placeholder="Select commodity to view" clearable
              :input-props="{ autocomplete: Math.random() }" class="dash-actions__commodity-select" size="small" />

            <NButton size="small" :disabled="isDisabled" @click="getTableData()" color="#213ce5"
              style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent; flex-shrink: 0;"
              @mouseenter="e => e.currentTarget.style.border = '1px solid #00aeef'"
              @mouseleave="e => e.currentTarget.style.border = '1px solid transparent'">
              Refresh
            </NButton>

            <div class="relative inline-block">
              <button class="dash-action-btn" :disabled="tableData.length === 0" @click="menuOpen = !menuOpen">
                <img :src="DDICONS.download" alt="" class="dash-action-btn__icon" />
                Export Data
              </button>
              <div v-show="menuOpen" class="split-menu" role="menu">
                <button role="menuitem" @click="handleExportExcel">Export as Excel</button>
                <button role="menuitem" @click="handleExportCSV">Export as CSV</button>
              </div>
            </div>

            <div v-if="activeTab === 'Trade Flow' && (importSankeyData.length || exportSankeyData.length)" class="relative inline-block">
              <button class="dash-action-btn" @click="chartMenuOpen = !chartMenuOpen">
                <img :src="DDICONS.download" alt="" class="dash-action-btn__icon" />
                Export Graphic
              </button>
              <div v-show="chartMenuOpen" class="split-menu" role="menu">
                <button role="menuitem" @click="exportChartAs('png'); chartMenuOpen = false;">Export as PNG</button>
                <button role="menuitem" @click="exportChartAs('svg'); chartMenuOpen = false;">Export as SVG</button>
              </div>
            </div>

            <span class="dash-actions__disclaimer" @click="() => showDisclaimer = true"><em>Disclaimer</em></span>
          </div>
        </div>

        <div v-if="needsRefresh && activeTab != 'Trade Flow'" class="col-12">
          <div class="dash-empty-state">
            Select a commodity and product, then click&nbsp;<strong>Refresh</strong>&nbsp;to load data.
          </div>
        </div>

        <div v-if="activeTab == 'Trade Flow'" class="col-12">
          <div class="trade-flow-hs-row">
            <div class="trade-flow-hs-row__group">
              <NSelect v-model:value="importHsCode" :options="IMPORT_HS_CODE_OPTS" :disabled="tradeFlowLoading.import"
                :loading="tradeFlowLoading.import" :theme-overrides="inputTheme" filterable clearable
                :placeholder="FILTERS.COUNTRY && !IMPORT_HS_CODE_OPTS.length ? 'No import data' : 'Select HS Code'"
                :input-props="{ autocomplete: Math.random() }"
                class="trade-flow-hs-row__select" size="small" />
              <NButton size="small" :disabled="!importHsCode || !FILTERS.COUNTRY" :loading="tradeFlowLoading.import"
                @click="fetchTradeFlow('import')" color="#213ce5"
                style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent;">
                Search
              </NButton>
            </div>

            <div class="trade-flow-hs-row__label">
              <div v-if="importSankeyData.length" class="tf-header-side tf-header-side--left">
                <span class="tf-header-direction">Imports</span>
                <span class="tf-header-vol tf-header-vol--in">
                  {{ fmtTradeVol(totalImportVolume) }}{{ tradeFlowVolumeUnits ? ' ' + tradeFlowVolumeUnits : '' }}
                </span>
              </div>
              <span v-if="importSankeyData.length" class="trade-flow-hs-row__arrow">→</span>
              <div class="tf-header-country">
                {{ selectedCountryLabel }}
              </div>
              <span v-if="exportSankeyData.length" class="trade-flow-hs-row__arrow">→</span>
              <div v-if="exportSankeyData.length" class="tf-header-side tf-header-side--right">
                <span class="tf-header-direction">Exports</span>
                <span class="tf-header-vol tf-header-vol--out">
                  {{ fmtTradeVol(totalExportVolume) }}{{ tradeFlowVolumeUnits ? ' ' + tradeFlowVolumeUnits : '' }}
                </span>
              </div>
            </div>
            <div class="trade-flow-hs-row__group">
              <NSelect v-model:value="exportHsCode" :options="EXPORT_HS_CODE_OPTS" :disabled="tradeFlowLoading.export"
                :loading="tradeFlowLoading.export" :theme-overrides="inputTheme" filterable clearable
                :placeholder="FILTERS.COUNTRY && !EXPORT_HS_CODE_OPTS.length ? 'No export data' : 'Select HS Code'"
                :input-props="{ autocomplete: Math.random() }"
                class="trade-flow-hs-row__select" size="small" />
              <NButton size="small" :disabled="!exportHsCode || !FILTERS.COUNTRY" :loading="tradeFlowLoading.export"
                @click="fetchTradeFlow('export')" color="#213ce5"
                style="background: linear-gradient(90deg, #213ce5, #2380f2); border: 1px solid transparent;">
                Search
              </NButton>
            </div>
          </div>
          <!-- View toggle + centred controls -->
          <div class="tf-toolbar">
            <div class="tf-view-toggle">
              <button :class="['tf-view-btn', { active: chartView === 'sankeynormal' }]" @click="setChartView('sankeynormal')">
                <img :src="DDICONS.sankey" alt="" class="dash-action-btn__icon" />
                Sankey
              </button>
              <button :class="['tf-view-btn', { active: chartView === 'radial' }]" @click="setChartView('radial')">
                <img :src="DDICONS.radial" alt="" class="dash-action-btn__icon" />
                Radial
              </button>
              <button :class="['tf-view-btn', { active: chartView === 'map' }]" @click="setChartView('map')">
                <img :src="DDICONS.map" alt="" class="dash-action-btn__icon" />
                Map
              </button>
            </div>
            <NSwitch v-if="chartView !== 'map' && (importSankeyData.length || exportSankeyData.length)" class="tf-log-toggle" title="Toggle linear / normalised scaling"
              :value="normalised" @update:value="toggleNormalised" :rail-style="railStyle" :round="false" size="small">
              <template #checked>Normalised</template>
              <template #unchecked>Linear</template>
            </NSwitch>
            <!-- Top N / Focus / Reset — centred in toolbar (shared across all views) -->
            <div v-if="importSankeyData.length || exportSankeyData.length" class="tf-toolbar-centre">
              <button :class="['tf-rail-btn tf-rail-btn--inline', { active: activeFilter === 'topn' }]" @click="toggleFilter('topn')" title="Top N per side">
                <img :src="DDICONS.topN" alt="" class="dash-action-btn__icon" />
                <span>Top N</span>
              </button>
              <button :class="['tf-rail-btn tf-rail-btn--inline', { active: activeFilter === 'spotlight' || spotlightCountries.length }]" @click="toggleFilter('spotlight')" title="Spotlight countries">
                <img :src="DDICONS.focus" alt="" class="dash-action-btn__icon" />
                <span>Focus</span>
                <span v-if="spotlightCountries.length" class="tf-rail-badge tf-rail-badge--inline">{{ spotlightCountries.length }}</span>
              </button>
              <button class="tf-rail-btn tf-rail-btn--inline tf-rail-btn--reset" @click="resetFilters" title="Reset all filters">
                <img :src="DDICONS.reset" alt="" class="dash-action-btn__icon" />
                <span>Reset</span>
              </button>
            </div>
          </div>
          <!-- Chart container: always fits the remaining viewport height, never scrolls -->
          <div ref="tradeFlowCaptureDiv" class="tf-chart-container">
            <div class="tf-chart-canvas" :style="{ height: viewportChartHeight + 'px' }">
              <p v-if="!importSankeyData.length && !exportSankeyData.length"
                style="position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; margin: 0; color: #9dabaf; font-size: 13px;">
                Select a country, choose an HS Code and click Search to view the trade flow.
              </p>
              <svg ref="svgRef" style="position: absolute; inset: 0; width: 100%; height: 100%;"></svg>
              <!-- Map arc thickness: corner button that slides a slider out -
                   left out of exported graphics -->
              <div v-if="chartView === 'map' && (importSankeyData.length || exportSankeyData.length)" class="tf-arc-width tf-no-export">
                <Transition name="tf-arc-width-slide">
                  <label v-if="arcWidthOpen" class="tf-arc-width__panel">
                    <span>Flow thickness</span>
                    <input type="range" min="0.25" max="4" step="0.25" :value="mapArcScale"
                      @input="onMapArcScale($event.target.valueAsNumber)" />
                    <span class="tf-arc-width__value">{{ mapArcScale }}×</span>
                  </label>
                </Transition>
                <button :class="['tf-arc-width__btn', { active: arcWidthOpen }]" title="Flow thickness"
                  @click="arcWidthOpen = !arcWidthOpen">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M2 3.5h12" stroke="currentColor" stroke-width="1" stroke-linecap="round"/><path d="M2 7.5h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="M2 12h12" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/></svg>
                </button>
              </div>
            </div>
            <!-- LEFT rail: Import filter -->
            <div v-if="importSankeyData.length" class="tf-filter-rail tf-filter-rail--left">
              <button :class="['tf-rail-btn', { active: activeFilter === 'impFilter' || effectiveImportFilter.length }]"
                @click="toggleFilter('impFilter')" title="Filter import countries">
                <img :src="DDICONS.imports" alt="" class="dash-action-btn__icon" />
                <span>Imports</span>
                <span v-if="effectiveImportFilter.length" class="tf-rail-badge">{{ effectiveImportFilter.length }}</span>
              </button>
            </div>
            <!-- RIGHT rail: Export filter -->
            <div v-if="exportSankeyData.length" class="tf-filter-rail tf-filter-rail--right">
              <button :class="['tf-rail-btn', { active: activeFilter === 'expFilter' || effectiveExportFilter.length }]"
                @click="toggleFilter('expFilter')" title="Filter export countries">
                <img :src="DDICONS.exports" alt="" class="dash-action-btn__icon" />
                <span>Exports</span>
                <span v-if="effectiveExportFilter.length" class="tf-rail-badge">{{ effectiveExportFilter.length }}</span>
              </button>
            </div>

            <!-- Filter overlay panels -->
            <transition name="tf-panel">
              <div v-if="activeFilter" ref="filterPanelRef" class="tf-filter-panel"
                   :class="activeFilter === 'impFilter' ? 'tf-filter-panel--left' : activeFilter === 'expFilter' ? 'tf-filter-panel--right' : 'tf-filter-panel--centre'">
                <!-- Top N panel -->
                <div v-if="activeFilter === 'topn'">
                  <div class="tf-panel-title">Top N per side</div>
                  <div class="tf-chip-row">
                    <button v-for="n in [5,10,15,20]" :key="n"
                      :class="['tf-chip', { active: filterTopN === n }]"
                      @click="filterTopN = n; drawSankeyChart()">{{ n }}</button>
                    <button :class="['tf-chip', { active: filterTopN === 999 }]"
                      @click="filterTopN = 999; drawSankeyChart()">All</button>
                  </div>
                  <p class="tf-panel-hint">Only applies when no specific countries are selected.</p>
                  <p v-if="filterTopN === 999 && chartView !== 'map'" class="tf-panel-hint">
                    "All" shows as many partners as fit the chart; the smallest are grouped as "Other". The map shows every partner.
                  </p>
                </div>
                <!-- Import filter panel -->
                <div v-if="activeFilter === 'impFilter'">
                  <div class="tf-panel-header">
                    <div class="tf-panel-title">Filter Imports</div>
                    <button v-if="effectiveImportFilter.length" class="tf-clear-link" @click="clearFilter('imp')">Clear all</button>
                  </div>
                  <p class="tf-panel-hint">Countries within a selected region that are also individually selected are shown separately and excluded from the region total.</p>
                  <input v-model="importFilterSearch" placeholder="Search countries or regions…" class="tf-search-input" />
                  <div class="tf-country-list modern-scrollbar">
                    <div v-for="group in importRegionGroups" :key="group.region" class="tf-region-group">
                      <button class="tf-region-header" @click="toggleRegionExpand('imp', group.region)">
                        <svg class="tf-region-chevron" :class="{ 'tf-region-chevron--open': isImportRegionOpen(group.region) }"
                          width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 1l4 3.5L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <span class="tf-check-box" :class="{ 'tf-check-box--checked': importRegionState(group) === 'full', 'tf-check-box--indeterminate': importRegionState(group) === 'partial' }" @click.stop="toggleCountry('impReg', group.region)">
                          <svg v-if="importRegionState(group) === 'full'" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          <svg v-else-if="importRegionState(group) === 'partial'" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5h6" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </span>
                        <span class="tf-region-name">{{ group.region }}</span>
                      </button>
                      <div v-if="isImportRegionOpen(group.region)" class="tf-region-countries">
                        <button v-for="name in group.countries" :key="name"
                          :class="['tf-country-item tf-country-item--check', { active: filterImportCountries.includes(name) }]"
                          @click="toggleCountry('imp', name)">
                          <span class="tf-check-box">
                            <svg v-if="filterImportCountries.includes(name)" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          </span>
                          {{ name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Export filter panel -->
                <div v-if="activeFilter === 'expFilter'">
                  <div class="tf-panel-header">
                    <div class="tf-panel-title">Filter Exports</div>
                    <button v-if="effectiveExportFilter.length" class="tf-clear-link" @click="clearFilter('exp')">Clear all</button>
                  </div>
                  <p class="tf-panel-hint">Countries within a selected region that are also individually selected are shown separately and excluded from the region total.</p>
                  <input v-model="exportFilterSearch" placeholder="Search countries or regions…" class="tf-search-input" />
                  <div class="tf-country-list modern-scrollbar">
                    <div v-for="group in exportRegionGroups" :key="group.region" class="tf-region-group">
                      <button class="tf-region-header" @click="toggleRegionExpand('exp', group.region)">
                        <svg class="tf-region-chevron" :class="{ 'tf-region-chevron--open': isExportRegionOpen(group.region) }"
                          width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 1l4 3.5L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <span class="tf-check-box" :class="{ 'tf-check-box--checked': exportRegionState(group) === 'full', 'tf-check-box--indeterminate': exportRegionState(group) === 'partial' }" @click.stop="toggleCountry('expReg', group.region)">
                          <svg v-if="exportRegionState(group) === 'full'" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          <svg v-else-if="exportRegionState(group) === 'partial'" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5h6" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </span>
                        <span class="tf-region-name">{{ group.region }}</span>
                      </button>
                      <div v-if="isExportRegionOpen(group.region)" class="tf-region-countries">
                        <button v-for="name in group.countries" :key="name"
                          :class="['tf-country-item tf-country-item--check', { active: filterExportCountries.includes(name) }]"
                          @click="toggleCountry('exp', name)">
                          <span class="tf-check-box">
                            <svg v-if="filterExportCountries.includes(name)" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          </span>
                          {{ name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Spotlight panel (multi-select, fades non-selected) -->
                <div v-if="activeFilter === 'spotlight'">
                  <div class="tf-panel-header">
                    <div class="tf-panel-title">Spotlight</div>
                    <button v-if="spotlightCountries.length" class="tf-clear-link" @click="clearFilter('spot')">Clear all</button>
                  </div>
                  <p class="tf-panel-hint">Selected countries stay bright — all others fade. Click a region to spotlight every country in it at once.</p>
                  <input v-model="spotlightSearch" placeholder="Search countries or regions…" class="tf-search-input" />
                  <div class="tf-country-list modern-scrollbar">
                    <div v-for="group in spotlightRegionGroups" :key="group.region" class="tf-region-group">
                      <button class="tf-region-header" @click="toggleRegionExpand('spot', group.region)">
                        <svg class="tf-region-chevron" :class="{ 'tf-region-chevron--open': isSpotlightRegionOpen(group.region) }"
                          width="9" height="9" viewBox="0 0 9 9" fill="none"><path d="M2 1l4 3.5L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <span class="tf-check-box" :class="{ 'tf-check-box--checked': spotlightRegionState(group) === 'full', 'tf-check-box--indeterminate': spotlightRegionState(group) === 'partial' }" @click.stop="toggleSpotlightRegion(group.region)">
                          <svg v-if="spotlightRegionState(group) === 'full'" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          <svg v-else-if="spotlightRegionState(group) === 'partial'" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M2 5h6" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/></svg>
                        </span>
                        <span class="tf-region-name">{{ group.region }}</span>
                      </button>
                      <div v-if="isSpotlightRegionOpen(group.region)" class="tf-region-countries">
                        <button v-for="name in group.countries" :key="name"
                          :class="['tf-country-item tf-country-item--check', { active: spotlightCountries.includes(name) }]"
                          @click="toggleCountry('spot', name)">
                          <span class="tf-check-box">
                            <svg v-if="spotlightCountries.includes(name)" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M1.5 5l2.5 2.5 4.5-4" stroke="#fff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                          </span>
                          {{ name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </transition>
            <!-- Source/date stamp, only rendered into exported graphics (the page
                 already shows it below the tabs) -->
            <div v-if="isExportingChart" class="tf-export-source">
              <p style="font-size: smaller;"><em>Source: Project Blue</em></p>
              <p style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate }}</em></p>
            </div>
          </div>
        </div>

        <div v-if="!needsRefresh && (activeTab == 'Supply' || activeTab == 'Trade')" class="col-12">
          <div class="table-scroll modern-scrollbar">
            <NDataTable :style="{ width: activeTableWidth + 'px' }" :scroll-x="-1" max-height="60vh" table-layout="fixed" :indent="0" :columns="activeColumns"
              :data="tableData" :row-key="rowKey" :row-class-name="rowClassName" v-model:expanded-row-keys="expandedRowKeys" />
          </div>
        </div>
        <p style="font-size: smaller;"><em>Source: Project Blue</em></p>
        <p style="font-size: smaller; margin-top: -15px;"><em>Accessed: {{ updatedDate
            }}</em></p>
      </div>
    </div>
  </div>
  <NDrawer v-model:show="showDisclaimer" :width="400" :height="200" placement="right">
    <TermsAndConditions />
  </NDrawer>
</template>

<script setup>
import { ref, reactive, computed, watch, h, onMounted, onAfterMount, onBeforeUnmount, nextTick } from "vue";
import { NSelect, NDataTable, NDatePicker, NButton, NDrawer, NScrollbar, NSwitch, NTabs, NTabPane } from "naive-ui";
import DynamicChart from "@/components/DynamicChart.vue";
import { SUBSCRIPTION_INFO } from "@/composables/subscription";
import {
  getCountryDataSupply,
  getCountryDataTrade,
  getCountryTradeFlowData,
  getCountryRegionMap,
  getTradeFlowHsCodesBySide,
  getGlobalTradeFlowData,
  tradeFlowYearSpan,
  countryData,
  countryDataSupply,
  products,
  countries,
  getCommodityProductsAndCountries
}
  from "@/composables/marketData/datadashboards";

//graph imports
import * as d3 from 'd3';
import { loadWorldMap, drawFlowMap, pinTooltipLines, setFlowMapWidthScale } from '@/composables/marketData/worldMap';

import * as htmlToImage from 'html-to-image';
import TermsAndConditions from "./TermsAndConditions.vue";
import { exportToCSV, exportToExcel } from "../../composables/marketData/datadashboards";
import { DDICONS } from "../../composables/generics";
import { logUserAction, logUserActionDebounced, USER_ACTIONS } from "@/composables/userLogs";

let isMounted = false;
let isResettingExpanded = false;

const activeTab = ref("Supply");
const dataTab = ref("Supply");
let tableWidth = ref(2500);
let tableWidthTrade = ref(2500);

// Track tab switches within Country Focus
watch(activeTab, (tab) => {
  logUserAction(
    USER_ACTIONS.VIEW_DASHBOARD,
    `Switched Country Focus tab to: "${tab}" (Country: "${selectedCountryLabel.value}")`
  );
});
const inputTheme = {
  peers: {
    InternalSelection: {
      borderHover: '1px solid #213ce5',
      borderFocus: '1px solid #213ce5',
      borderActive: '1px solid #213ce5',
      boxShadowFocus: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowActive: '0 0 0 2px rgba(33, 60, 229, 0.2)',
      boxShadowHover: 'none',
      caretColor: '#213ce5',
      arrowColorActive: '#213ce5',
      arrowColorHover: '#213ce5',
      color: '#fff',
      colorActive: '#ffffff',
      colorFocus: '#ffffff',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    },
    InternalSelectMenu: {
      optionColorActive: 'rgba(33, 60, 229, 0.08)',
      optionColorActivePending: 'rgba(33, 60, 229, 0.12)',
      optionColorPending: 'rgba(33, 60, 229, 0.05)',
      optionTextColorActive: '#213ce5',
      optionTextColorChildActive: '#213ce5',
      optionCheckColor: '#213ce5',
      actionDividerColor: '#213ce5',
      loadingColor: '#213ce5',
      scrollbarColor: 'rgba(33, 60, 229, 0.3)',
      scrollbarColorHover: 'rgba(33, 60, 229, 0.5)',
      fontFamily: "'GilroyMedium', sans-serif",
      fontSize: '11px !important',
    }
  }
};

// Trade Flow tab: countries with a non-zero trade flow volume (as exporter or
// partner) in the selected year - null until loaded / on other tabs, where the
// list isn't year-filtered.
const tradeFlowYearCountries = ref(null);
let tradeFlowCountriesSeq = 0;
const refreshTradeFlowYearCountries = async () => {
  const seq = ++tradeFlowCountriesSeq;
  if (activeTab.value !== 'Trade Flow' || !FILTERS.ELEMENT) { tradeFlowYearCountries.value = null; return; }
  const year = String(new Date(searchYear.value).getFullYear());
  const rows = await getGlobalTradeFlowData(FILTERS.ELEMENT, null, year, year);
  if (seq !== tradeFlowCountriesSeq) return; // superseded by a newer year/commodity/tab
  const available = new Set();
  for (const r of rows) {
    // Same rows the charts use: EXPORT volume rows (country exports to tradePartner)
    if (!(r.typeName || '').toLowerCase().includes('export')) continue;
    if (r.productVariety?.toLowerCase() !== 'volume') continue;
    if (!Number(r.yearlyData?.[year])) continue;
    if (r.country) available.add(r.country);
    if (r.tradePartner) available.add(r.tradePartner);
  }
  tradeFlowYearCountries.value = available;
};

const COUNTRY_OPTS = computed(() => {
  const yearFilter = activeTab.value === 'Trade Flow' ? tradeFlowYearCountries.value : null;
  return (countries.value ?? []).filter(nth => !yearFilter || yearFilter.has(nth.code)).map((nth) => {
    return {
      label: nth.name,
      value: nth.code,
    }
  }).sort((a, b) => String(a.label ?? '').localeCompare(String(b.label ?? '')));
});


const FILTERS = reactive({
  SUBSCRIPTION: null,
  ELEMENT: null,
  SUB_ELEMENT: null,
  COMPANY: null,
  COUNTRY: null,
  ASSET: null,
  PRODUCT: null
});

const ELEMENT_OPTS = computed(() => {
  return SUBSCRIPTION_INFO?.dataElements?.map((nth) => {
    return {
      label: nth.name,
      value: nth.code,
    }
  })
});

const GRAPH_VIEW_OPTIONS = ref([
  //{ label: 'Area Chart', value: 'stacked' },
  { label: 'Bar Chart', value: 'bar' },
  { label: 'Line Chart', value: 'line' },
  // { label: 'Stacked Chart', value: 'line' } - TODO
])
const decimals = ref(0);
const supplyUom = ref("Supply");
const isSearch = ref(false);
const lastYearStart = ref(2015);
const lastYearEnd = ref(2035);
const searchYear = ref(new Date(2025, 0));
const showDisclaimer = ref(false);
const loadAll = ref(false);
const captureDiv = ref(null);
const showOptions = ref(false);
const isLoading = ref(true);
const showToast = ref(false);
const needsRefresh = ref(false);
const displayType = ref("Table");

const graphView = ref(GRAPH_VIEW_OPTIONS.value[0].value);
const yearsView = ref([
  (new Date(2015, 0)).getTime(),
  (new Date(2035, 0)).getTime(),
]);

const updatedDate = ref(new Date())

// ── Trade flow (Sankey) ── declared early so the computeds/watchers below (which
// evaluate eagerly to set up reactive tracking) don't hit a temporal-dead-zone error.
const importHsCode = ref(null);
const exportHsCode = ref(null);
const importSankeyData = ref([]); // [{ from, to, flow }]
const exportSankeyData = ref([]); // [{ from, to, flow }]
const tradeFlowLoading = reactive({ import: false, export: false });

// ── Chart view + filter state ─────────────────────────────────────────────────
const chartView             = ref('radial');  // 'sankeynormal' | 'radial' | 'map'
const normalised            = ref(false);     // linear vs normalised (smaller side stretched) ribbon scaling
const activeFilter          = ref(null);      // which filter panel is open
const filterTopN            = ref(10);        // max countries per side (when no specific filter)
const filterDirection       = ref('both');    // kept for compat (not shown in UI)

// Specific country filters — empty = show all (up to Top N); non-empty = show only these
const filterImportCountries = ref([]);
const filterExportCountries = ref([]);
const importFilterSearch    = ref('');
const exportFilterSearch    = ref('');

// Which regions are expanded (accordion open) in each filter panel
const expandedImportRegions = ref([]);
const expandedExportRegions = ref([]);

const filterImportRegions   = ref([]);

const filterExportRegions   = ref([]);

// Spotlight (multi-select â€" fades everything not in the set)
const spotlightCountries    = ref([]);
const spotlightSearch       = ref('');
const expandedSpotlightRegions = ref([]);

// Region map: country name → region string â€" loaded once from country/getCountries API
const countryRegionMap = ref({});

// Computed partner lists (sorted)
const importPartnerNames = computed(() =>
  [...new Set(importSankeyData.value.map(l => l.from))].sort()
);
// A partner the country both imports from and exports to is listed on both
// sides - imports and exports are separate columns, so there's no cycle.
const exportPartnerNames = computed(() =>
  [...new Set(exportSankeyData.value.map(l => l.to))].sort()
);
const allPartnerNames = computed(() =>
  [...new Set([...importPartnerNames.value, ...exportPartnerNames.value])].sort()
);

// Badge counts: number of individual countries + number of selected regions
const effectiveImportFilter = computed(() =>
  [...filterImportCountries.value, ...filterImportRegions.value]
);

const effectiveExportFilter = computed(() =>
  [...filterExportCountries.value, ...filterExportRegions.value]
);

// Alphabetical, region-grouped accordion data for the filter panels.
// Countries with no known region are bucketed under "Other".
function buildRegionGroups(partnerNames, regionMap, search) {
  const q = search.toLowerCase();
  const byRegion = {};
  partnerNames.forEach(name => {
    const region = regionMap[name] || 'Other';
    (byRegion[region] ??= []).push(name);
  });
  return Object.keys(byRegion).sort().map(region => ({
    region,
    countries: byRegion[region].sort(),
  })).map(group => {
    if (!q) return group;
    const regionMatches = group.region.toLowerCase().includes(q);
    const countries = regionMatches ? group.countries : group.countries.filter(n => n.toLowerCase().includes(q));
    return { region: group.region, countries };
  }).filter(group => group.countries.length);
}

const importRegionGroups = computed(() =>
  buildRegionGroups(importPartnerNames.value, countryRegionMap.value, importFilterSearch.value)
);
const exportRegionGroups = computed(() =>
  buildRegionGroups(exportPartnerNames.value, countryRegionMap.value, exportFilterSearch.value)
);

// Spotlight has no separate "region" selection value like import/export do
// (it's just a flat set of highlighted country names) - the region header's
// checkbox is a bulk select-all/clear-all for that region's countries instead
// of a persisted aggregate entry.
const spotlightRegionGroups = computed(() =>
  buildRegionGroups(allPartnerNames.value, countryRegionMap.value, spotlightSearch.value)
);
function spotlightRegionState(group) {
  const selected = group.countries.filter(n => spotlightCountries.value.includes(n)).length;
  if (selected === 0) return 'none';
  return selected === group.countries.length ? 'full' : 'partial';
}
function toggleSpotlightRegion(region) {
  const group = spotlightRegionGroups.value.find(g => g.region === region);
  if (!group) return;
  const allSelected = group.countries.every(n => spotlightCountries.value.includes(n));
  spotlightCountries.value = allSelected
    ? spotlightCountries.value.filter(n => !group.countries.includes(n))
    : [...new Set([...spotlightCountries.value, ...group.countries])];
  drawSankeyChart();
}

function toggleRegionExpand(side, region) {
  const r = side === 'imp' ? expandedImportRegions : side === 'exp' ? expandedExportRegions : expandedSpotlightRegions;
  const idx = r.value.indexOf(region);
  r.value = idx === -1 ? [...r.value, region] : r.value.filter(n => n !== region);
}

// A region showing because of an active search is a TEMPORARY visibility
// state, not a persisted one — it must not be baked into expandedXRegions,
// or clearing the search leaves every region stuck open forever (since
// nothing ever removes them again except one-by-one manual clicks). These
// combine the persisted (manually toggled via the chevron only) state with
// "is a search currently active" purely for display. Selecting a
// region/country as a filter must NOT also expand or collapse its accordion
// section — those are two separate actions, only toggleRegionExpand controls
// expand/collapse.
const isImportRegionOpen = (region) => !!importFilterSearch.value || expandedImportRegions.value.includes(region);
const isExportRegionOpen = (region) => !!exportFilterSearch.value || expandedExportRegions.value.includes(region);
const isSpotlightRegionOpen = (region) => !!spotlightSearch.value || expandedSpotlightRegions.value.includes(region);

const _filterRefs = {
  imp: filterImportCountries,
  exp: filterExportCountries,
  impReg: filterImportRegions,
  expReg: filterExportRegions,
  spot: spotlightCountries,
};
function toggleCountry(key, name) {
  const r = _filterRefs[key];
  const idx = r.value.indexOf(name);
  r.value = idx === -1 ? [...r.value, name] : r.value.filter(n => n !== name);
  drawSankeyChart();
}

// Region checkbox tri-state: 'partial' (dash) if any of its countries are individually
// selected, 'full' (check) if only the region itself is selected, otherwise 'none'.
function regionCheckState(selectedRegions, selectedCountries, group) {
  if (group.countries.some(n => selectedCountries.includes(n))) return 'partial';
  if (selectedRegions.includes(group.region)) return 'full';
  return 'none';
}
function importRegionState(group) {
  return regionCheckState(filterImportRegions.value, filterImportCountries.value, group);
}
function exportRegionState(group) {
  return regionCheckState(filterExportRegions.value, filterExportCountries.value, group);
}
function clearFilter(key) {
  if (key === 'imp') { filterImportCountries.value = []; filterImportRegions.value = []; }
  else if (key === 'exp') { filterExportCountries.value = []; filterExportRegions.value = []; }
  else _filterRefs[key].value = [];
  drawSankeyChart();
}

// Every view defaults to linear scaling.
function setChartView(v) {
  chartView.value = v;
  normalised.value = false;
  activeFilter.value = null;
  // Track chart view switch (sankeynormal, radial, map)
  logUserAction(
    USER_ACTIONS.VIEW_TRADE_FLOW,
    `Switched Country Trade Flow view to: "${v}" (Country: "${selectedCountryLabel.value}")`
  );
  nextTick(() => drawSankeyChart());
}

function toggleNormalised() {
  normalised.value = !normalised.value;
  // Track linear vs normalised toggle
  logUserAction(
    USER_ACTIONS.FILTER_TRADE_FLOW,
    `Toggled Country Trade Flow scale: "${normalised.value ? 'Normalised' : 'Linear'}" (Country: "${selectedCountryLabel.value}")`
  );
  drawSankeyChart();
}

// Ribbon scales [kImports, kExports] for the Radial and Sankey views.
// sideScale(items) is the largest k at which that side's column fits.
// Linear: one shared k, so import and export widths compare directly.
// Normalised: the bigger side (by total flow) keeps its linear scale and only
// the smaller side is stretched up to the same total height, so its partners'
// shares are readable - ribbons stay proportional within each side. The bigger
// side never moves: if the smaller side has too many rows (gaps + minimum
// widths) to reach that height, it stretches only as far as it fits.
function ribbonScales(imports, exports, sideScale, normalise) {
  const k = Math.min(sideScale(imports), sideScale(exports));
  const total = items => items.reduce((s, l) => s + l.value, 0);
  const tImp = total(imports), tExp = total(exports);
  if (!normalise || !tImp || !tExp) return [k, k];
  const importsBigger = tImp >= tExp;
  const [big, small] = importsBigger ? [imports, exports] : [exports, imports];
  const kSmall = Math.min(k * total(big) / total(small), sideScale(small));
  return importsBigger ? [k, kSmall] : [kSmall, k];
}

function toggleFilter(name) {
  activeFilter.value = activeFilter.value === name ? null : name;
}

// Close filter panel when clicking outside the panel and its trigger buttons

function onDocMouseDown(e) {
  if (!activeFilter.value) return;
  // Stay open if click is inside the panel itself
  if (filterPanelRef.value && filterPanelRef.value.contains(e.target)) return;
  // Stay open if click is on any rail/toolbar button (let it toggle)
  if (e.target.closest('.tf-rail-btn')) return;
  activeFilter.value = null;
}

function resetFilters() {
  filterTopN.value             = 10;
  filterDirection.value        = 'both';
  filterImportCountries.value  = [];
  filterExportCountries.value  = [];
  filterImportRegions.value    = [];
  filterExportRegions.value    = [];
  spotlightCountries.value     = [];
  importFilterSearch.value     = '';
  exportFilterSearch.value     = '';
  spotlightSearch.value        = '';
  activeFilter.value           = null;
  drawSankeyChart();
}

function setType(type) {
  displayType.value = type;
  localStorage.setItem("displayTypeSupply", type);
}

// Matches the Filtered/All data switch on the Trade market data page
function railStyle({ focused }) {
  const style = {
    fontSize: '14px',
    border: '1px solid transparent',
    height: '20px',
    background: 'linear-gradient(90deg, #213ce5, #2380f2)',
  };
  if (focused) style.boxShadow = 'none';
  return style;
}



const svgRef = ref(null);
const tradeFlowCaptureDiv = ref(null);

const filterPanelRef = ref(null);

const chartMenuOpen = ref(false);

const isExportingChart = ref(false);

const handleExportExcel = () => {
  menuOpen.value = false;
  exportToExcel(tableData.value, minYear.value, maxYear.value, `${activeTab.value}.xlsx`, activeTab.value.toLowerCase());
  // Track spreadsheet download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Country Focus data as Excel (${activeTab.value}, Country: "${selectedCountryLabel.value}")`
  );
};

const handleExportCSV = () => {
  menuOpen.value = false;
  exportToCSV(tableData.value, minYear.value, maxYear.value, `${activeTab.value}.csv`, activeTab.value.toLowerCase());
  // Track CSV download
  logUserAction(
    USER_ACTIONS.DOWNLOAD_DASHBOARD_DATA,
    `Exported Country Focus data as CSV (${activeTab.value}, Country: "${selectedCountryLabel.value}")`
  );
};

const exportChartAs = async (type) => {
  const el = tradeFlowCaptureDiv.value;
  if (!el) return;

  // Track Trade Flow graphic export
  logUserAction(
    USER_ACTIONS.DOWNLOAD_TRADE_FLOW_GRAPH,
    `Exported Country Trade Flow graphic as ${type.toUpperCase()} (Country: "${selectedCountryLabel.value}")`
  );

  const fn = type === 'svg' ? htmlToImage.toSvg : htmlToImage.toPng;
  const ext = type === 'svg' ? 'svg' : 'png';
  // Leave the on-chart filter controls (Imports/Exports rail buttons and any
  // open filter panel) out of the exported graphic.
  const filter = node => !node.classList?.contains('tf-filter-rail') && !node.classList?.contains('tf-filter-panel')
    && !node.classList?.contains('tf-no-export');
  // Render the Source/Accessed stamp into the capture area just for the export
  isExportingChart.value = true;
  await nextTick();
  try {
    const dataUrl = await fn(el, { filter });
    const link = document.createElement('a');
    link.download = `trade-flow.${ext}`;
    link.href = dataUrl;
    link.click();
  } finally {
    isExportingChart.value = false;
  }
};

let chartInstance = null; // kept for cleanup guard
let _resizeObserver = null;

const selectedCountryLabel = computed(() => {
  return COUNTRY_OPTS.value.find(nth => nth.value === FILTERS.COUNTRY)?.label || FILTERS.COUNTRY || "Country";
});

const totalImportVolume = computed(() => importSankeyData.value.reduce((s, l) => s + l.flow, 0));

const totalExportVolume = computed(() => exportSankeyData.value.reduce((s, l) => s + l.flow, 0));

const tradeFlowVolumeUnits = computed(() =>
  importSankeyData.value[0]?.units || exportSankeyData.value[0]?.units || ''
);

const fmtTradeVol = (v) => Number(v).toLocaleString('en', { maximumFractionDigits: 0 });

// The chart always fits within whatever vertical space is left in the viewport
// below it - it never grows the page or scrolls. Partner labels don't need
// per-node vertical room to stay legible: renderPartnerLegend (below) packs
// them into fixed-height rows that flow into extra columns sideways instead,
// so label count is decoupled from how tall the canvas is.
const viewportChartHeight = ref(520);

// Map flow thickness slider: multiplies the map's arc widths. Applied in place,
// so dragging it keeps the current zoom/pan; the map draw passes it on redraws.
const mapArcScale = ref(1);
const arcWidthOpen = ref(false); // slider slid out from its corner button
function onMapArcScale(scale) {
  mapArcScale.value = scale;
  setFlowMapWidthScale(svgRef.value, scale);
}
function updateViewportChartHeight() {
  const el = tradeFlowCaptureDiv.value;
  if (!el) return;
  const top = el.getBoundingClientRect().top;
  viewportChartHeight.value = Math.max(420, Math.round(window.innerHeight - top - 24));
}

// HS code options for the Trade Flow tab — derived from uploaded Trade_flow data
// for the currently selected element/country, per side: each dropdown only
// offers codes that actually have flows in that direction for this country.
const IMPORT_HS_CODE_OPTS = ref([]);
const EXPORT_HS_CODE_OPTS = ref([]);
const hasCode = (opts, code) => !!code && opts.some(o => o.value === code);

let hsCodesSeq = 0;
const refreshHsCodes = async () => {
  // Commodity, country and tab can all change at once (e.g. opening a country
  // from the Trade Flow map), each kicking off a refresh - only the latest
  // may apply, or an older one (for the previous country) could land last.
  const seq = ++hsCodesSeq;
  if (!FILTERS.ELEMENT || !FILTERS.COUNTRY) {
    IMPORT_HS_CODE_OPTS.value = [];
    EXPORT_HS_CODE_OPTS.value = [];
  } else {
    const { imports, exports } = await getTradeFlowHsCodesBySide(FILTERS.ELEMENT, FILTERS.COUNTRY);
    if (seq !== hsCodesSeq) return;
    IMPORT_HS_CODE_OPTS.value = imports;
    EXPORT_HS_CODE_OPTS.value = exports;
  }
  // Drop a selection the new country/commodity has no data for on that side
  if (!hasCode(IMPORT_HS_CODE_OPTS.value, importHsCode.value)) importHsCode.value = null;
  if (!hasCode(EXPORT_HS_CODE_OPTS.value, exportHsCode.value)) exportHsCode.value = null;
};

watch(() => FILTERS.ELEMENT, () => {
  importHsCode.value = null;
  exportHsCode.value = null;
  if (activeTab.value === 'Trade Flow') refreshHsCodes();
});

watch(() => FILTERS.COUNTRY, () => {
  if (activeTab.value === 'Trade Flow') refreshHsCodes();
});

// A change of country/year/commodity invalidates the whole chart - clear it
// back to the "click Search" prompt so a stale flow is never shown against
// the new selection. (HS code changes only affect their own side - see below.)
watch(
  [() => FILTERS.ELEMENT, () => FILTERS.COUNTRY, searchYear],
  () => {
    if (!importSankeyData.value.length && !exportSankeyData.value.length) return;
    importSankeyData.value = [];
    exportSankeyData.value = [];
    activeFilter.value = null;
    if (svgRef.value) d3.select(svgRef.value).selectAll('*').remove();
  }
);

// Load one side ('import' | 'export') with that side's own HS code. A side
// with no HS code is emptied.
const loadTradeFlowSide = async (side) => {
  const isImport = side === 'import';
  const code = isImport ? importHsCode.value : exportHsCode.value;
  const target = isImport ? importSankeyData : exportSankeyData;
  target.value = [];
  if (!code || !FILTERS.COUNTRY || !FILTERS.ELEMENT) return;

  const year = new Date(searchYear.value).getFullYear();
  const countryLabel = selectedCountryLabel.value;
  const { ELEMENT: element, COUNTRY: country } = FILTERS;
  tradeFlowLoading[side] = true;
  try {
    const result = await getCountryTradeFlowData(element, country, code, year);
    // Superseded while loading (HS code, country, commodity or year changed)
    const stale = (isImport ? importHsCode.value : exportHsCode.value) !== code
      || FILTERS.ELEMENT !== element || FILTERS.COUNTRY !== country
      || new Date(searchYear.value).getFullYear() !== year;
    if (stale) return;
    target.value = ((isImport ? result?.imports : result?.exports) || []).map(p => ({
      from: isImport ? p.partner : countryLabel,
      to: isImport ? countryLabel : p.partner,
      flow: p.value,
      units: p.units || '',
      unitValue: p.unitValue ?? null,
      unitValueUnits: p.unitValueUnits || '',
    }));
  } finally {
    tradeFlowLoading[side] = false;
  }
};

const redrawTradeFlow = async () => {
  await nextTick();
  updateViewportChartHeight();
  await nextTick();
  drawSankeyChart();
};

// Search from one side, each with its own HS code. When both sides have an HS
// code selected, either button loads both; otherwise only the clicked side loads.
const fetchTradeFlow = async (side) => {
  if (!FILTERS.COUNTRY || !FILTERS.ELEMENT) return;

  // Track Trade Flow search by country
  logUserAction(
    USER_ACTIONS.SEARCH_TRADE_FLOW,
    `Searched Country Trade Flow: Country="${selectedCountryLabel.value}", Side="${side}", Year=${new Date(searchYear.value).getFullYear()}`
  );

  const sides = importHsCode.value && exportHsCode.value ? ['import', 'export'] : [side];
  await Promise.all(sides.map(loadTradeFlowSide));
  await redrawTradeFlow();
};

// Once a chart is showing, adding/changing/removing one side's HS code just
// updates that side in place - no need to clear the chart and search again.
// Before the first search it does nothing (Search is still what loads it).
[['import', importHsCode], ['export', exportHsCode]].forEach(([side, codeRef]) => {
  watch(codeRef, async () => {
    if (!importSankeyData.value.length && !exportSankeyData.value.length) return;
    await loadTradeFlowSide(side);
    await redrawTradeFlow();
  });
});

// ── Shared: dense partner-label legend ────────────────────────────────────────
// Placing a label at its own node's y-position breaks down once there are more
// partners than fit at one-row-per-node - node slivers shrink below text
// height and labels stack on top of each other. Decoupling label placement
// from node geometry fixes that: labels flow into fixed-height rows and spill
// into extra columns sideways (using the plentiful horizontal margin either
// side of the diagram) instead of demanding more vertical room. That keeps
// every view a fixed, viewport-fit height that never needs to scroll.
function legendColumnCount(count, rowsPerCol) {
  return Math.max(1, Math.ceil(count / rowsPerCol));
}
function renderPartnerLegend(svg, items, nameKey, { side, edgeX, top, rowH, rowsPerCol, colWidth, colorOf, dimmedOf }) {
  items.forEach((item, i) => {
    const name = item[nameKey];
    const col = Math.floor(i / rowsPerCol);
    const row = i % rowsPerCol;
    const cy = top + row * rowH + rowH / 2;
    const dimmed = dimmedOf ? dimmedOf(name) : false;
    const swatchAnchor = side === 'left' ? edgeX - 12 - col * colWidth : edgeX + 12 + col * colWidth;
    svg.append('rect')
      .attr('x', side === 'left' ? swatchAnchor - 8 : swatchAnchor).attr('y', cy - 4)
      .attr('width', 8).attr('height', 8).attr('rx', 1.5)
      .attr('fill', colorOf(name)).attr('fill-opacity', dimmed ? 0.25 : 1);
    svg.append('text')
      .attr('x', side === 'left' ? swatchAnchor - 12 : swatchAnchor + 12).attr('y', cy)
      .attr('text-anchor', side === 'left' ? 'end' : 'start').attr('dominant-baseline', 'middle')
      .attr('font-size', '10px').attr('font-family', 'system-ui, sans-serif')
      .attr('fill', dimmed ? '#c0c8d0' : '#192e40')
      .text(name);
  });
}

// Spreads one column's labels so they never overlap: `items` are { y, h }
// (label centre at its node's centre, label height), already in top→bottom
// node order. Sets `ly` on each - pushed down to clear the one above, then
// back up if the stack runs past `bottom`. Keeping node order means a label's
// connector to its node can't cross a neighbour's.
function spreadLabels(items, top, bottom) {
  let prevY = -Infinity, prevH = 0;
  items.forEach(it => {
    it.ly = Math.max(it.y, top + it.h / 2, prevY + (prevH + it.h) / 2);
    prevY = it.ly; prevH = it.h;
  });
  let nextY = Infinity, nextH = 0;
  for (let i = items.length - 1; i >= 0; i--) {
    const it = items[i];
    it.ly = Math.min(it.ly, bottom - it.h / 2, nextY - (nextH + it.h) / 2);
    nextY = it.ly; nextH = it.h;
  }
  return items;
}

// Draws a partner label (name, plus value on a second line when `twoLine`) at
// the spread position `ly`, with a short connector back to the node's centre
// `yc` whenever spreading moved it off the node.
function drawPartnerLabel(svg, { side, edgeX, yc, ly, name, value, twoLine, labelColor, valueColor }) {
  const dir = side === 'left' ? -1 : 1;
  const moved = Math.abs(ly - yc) > 1;
  const textX = edgeX + dir * (moved ? 18 : 8);
  if (moved) {
    svg.append('polyline')
      .attr('points', `${edgeX + dir * 2},${yc} ${edgeX + dir * 8},${yc} ${textX - dir * 3},${ly}`)
      .attr('fill', 'none').attr('stroke', '#c0c8d0').attr('stroke-width', 0.75);
  }
  const anchor = side === 'left' ? 'end' : 'start';
  svg.append('text')
    .attr('x', textX).attr('y', twoLine ? ly - 7 : ly)
    .attr('text-anchor', anchor).attr('dominant-baseline', 'middle')
    .attr('font-size', '11px').attr('font-weight', '500')
    .attr('fill', labelColor).attr('font-family', 'system-ui, sans-serif')
    .text(name);
  if (twoLine) {
    svg.append('text')
      .attr('x', textX).attr('y', ly + 7)
      .attr('text-anchor', anchor).attr('dominant-baseline', 'middle')
      .attr('font-size', '10px').attr('font-family', 'system-ui, sans-serif')
      .attr('fill', valueColor)
      .text(value);
  }
}

// Shared across every view's partner colouring, so the same country gets the
// same colour whichever view (Classic/Sankey/Radial/Map) is showing it.
// Brand colour palette (on white): primary, secondary, tertiary.
const BRAND_PALETTE = [
  '#213CE5','#00AEEF','#009A46','#92D050','#F0C302','#FFED05', // primary
  '#6801FF','#9484FF',                                         // secondary
  '#F25904','#FC9860',                                         // tertiary
];

async function drawSankeyChart() {
  const svgEl = svgRef.value;
  if (!svgEl) return;

  // Always clear before redraw so switching views doesn't leave stale content
  d3.select(svgEl).selectAll('*').remove();

  // ── Data prep (respects filter state) ────────────────────────────────────────
  // Every export is charted, including to partners that are also import
  // sources (e.g. Thailand ⇄ Myanmar): imports and exports are drawn as
  // separate columns, so a two-way partner simply appears on both sides (same
  // colour - partnerColorMap is keyed by name). These used to be filtered out,
  // which hid real trade and left the chart disagreeing with the header totals.
  const allExports = exportSankeyData.value;

  // The Sankey/Radial columns can only fit so many partner rows in the
  // (fixed, viewport-fitted) chart height. Past that, gaps + minimum ribbon
  // widths use up the whole column, every ribbon collapses to the minimum
  // width and linear/normalised look identical - so "All" (or a large Top N) is capped
  // at what fits, with the smallest partners folded into the "Other …" ribbon.
  // The map plots every country, so it isn't capped.
  const ROW_H = 14; // one label line + breathing room
  const maxRows = Math.max(5, Math.floor((viewportChartHeight.value - 60) / ROW_H));
  // Rows to show for a side: everything if it all fits, otherwise maxRows - 1
  // so the "Other …" ribbon gets the last row.
  const topNFor = (list) => chartView.value === 'map' || list.length <= Math.min(filterTopN.value, maxRows)
    ? filterTopN.value
    : Math.min(filterTopN.value, maxRows - 1);
  const regionMap   = countryRegionMap.value;
  const selImpCountries = filterImportCountries.value;  // individually picked import countries
  const selExpCountries = filterExportCountries.value;  // individually picked export countries
  const selImpRegions   = filterImportRegions.value;    // selected import regions
  const selExpRegions   = filterExportRegions.value;    // selected export regions
  const hasImpFilter = selImpCountries.length || selImpRegions.length;
  const hasExpFilter = selExpCountries.length || selExpRegions.length;
  /**
   * Build the ribbon list for one side applying both country and region filters.
   * - Individually selected countries → one ribbon each
   * - Selected regions → one aggregated ribbon per region (countries in that region
   *   that are NOT individually selected are lumped together)
   * - No filter → top N + "Other" bucket as before
   * Ribbons are grouped by region (alphabetically), with each region's aggregate
   * ribbon immediately followed by its individually selected countries (also
   * alphabetical) — so a country stays next to its region instead of being sorted
   * to wherever its own name happens to fall.
   */
  function buildFilteredRibbons(rows, partnerKey, isImport, selectedCountries, selectedRegions) {
    const countryNode = selectedCountryLabel.value;

    const regionRibbon = {};
    selectedRegions.forEach(region => {
      const regionRows = rows.filter(r => {
        const rName = r[partnerKey];
        return regionMap[rName] === region && !selectedCountries.includes(rName);
      });
      if (!regionRows.length) return;
      const totalFlow = regionRows.reduce((s, r) => s + r.flow, 0);
      const units = regionRows[0]?.units || '';
      const uv = combinedUnitValue(regionRows);
      regionRibbon[region] = isImport
        ? { from: region, to: countryNode, flow: totalFlow, units, ...uv, _isRegion: true }
        : { from: countryNode, to: region, flow: totalFlow, units, ...uv, _isRegion: true };
    });

    const countriesByRegion = {};
    selectedCountries.forEach(name => {
      const row = rows.find(r => r[partnerKey] === name);
      if (!row) return;
      const region = regionMap[name] || 'Other';
      (countriesByRegion[region] ||= []).push({ ...row });
    });

    const allRegions = [...new Set([...Object.keys(regionRibbon), ...Object.keys(countriesByRegion)])]
      .sort((a, b) => a.localeCompare(b));

    const ribbons = [];
    allRegions.forEach(region => {
      if (regionRibbon[region]) ribbons.push(regionRibbon[region]);
      const countries = (countriesByRegion[region] || [])
        .sort((a, b) => String(a[partnerKey]).localeCompare(String(b[partnerKey])));
      ribbons.push(...countries);
    });
    return ribbons;
  }
  // Import side
  let topImports;
  if (hasImpFilter) {
    topImports = buildFilteredRibbons(importSankeyData.value, 'from', true, selImpCountries, selImpRegions);
  } else {
    const TOP_N = topNFor(importSankeyData.value);
    topImports = importSankeyData.value.slice(0, TOP_N);
    const tailImports = importSankeyData.value.slice(TOP_N);
    if (tailImports.length) {
      topImports = [...topImports, {
        from: `Other importers (${tailImports.length})`,
        to: selectedCountryLabel.value,
        flow: tailImports.reduce((s, l) => s + l.flow, 0),
        units: tailImports.find(l => l.units)?.units,
        ...combinedUnitValue(tailImports),
        _isOther: true,
      }];
    }
  }
  // Export side
  let topExports;
  if (hasExpFilter) {
    topExports = buildFilteredRibbons(allExports, 'to', false, selExpCountries, selExpRegions);
  } else {
    const TOP_N = topNFor(allExports);
    topExports = allExports.slice(0, TOP_N);
    const tailExports = allExports.slice(TOP_N);
    if (tailExports.length) {
      topExports = [...topExports, {
        from: selectedCountryLabel.value,
        to: `Other destinations (${tailExports.length})`,
        flow: tailExports.reduce((s, l) => s + l.flow, 0),
        units: tailExports.find(l => l.units)?.units,
        ...combinedUnitValue(tailExports),
        _isOther: true,
      }];
    }
  }

  // Partner colours by volume: the biggest partner (imports + exports
  // combined) always gets the primary brand colour, the next biggest the next
  // palette colour, and so on. "Other …" buckets aren't a real partner, so they
  // rank after every real one regardless of size.
  const partnerColorMap = (() => {
    const totals = new Map(); // name → { flow, isOther }
    const add = (name, flow, isOther) => {
      if (name === selectedCountryLabel.value) return;
      const t = totals.get(name) || { flow: 0, isOther: !!isOther };
      t.flow += Number(flow) || 0;
      totals.set(name, t);
    };
    topImports.forEach(l => add(l.from, l.flow, l._isOther));
    topExports.forEach(l => add(l.to, l.flow, l._isOther));
    const ranked = [...totals].sort(([, a], [, b]) => (a.isOther - b.isOther) || (b.flow - a.flow));
    return Object.fromEntries(ranked.map(([name], i) => [name, BRAND_PALETTE[i % BRAND_PALETTE.length]]));
  })();

  if (chartView.value === 'sankeynormal') {
    // Sankey shares the same filters and scaling as Radial — only the layout
    // differs.
    if (!topImports.length && !topExports.length) return;

    drawSankeyD3Chart(svgEl, topImports, topExports, partnerColorMap, normalised.value);
    return;
  }

  if (chartView.value === 'map') {
    if (!topImports.length && !topExports.length) return;
    // All import arcs/dots share one colour and all exports share another
    // (rather than one colour per partner country), so the map reads at a
    // glance as "this is what flows in, this is what flows out".
    const mapColorOf = (name, link) => link?.side === 'export' ? '#009A46' : '#213CE5';
    const spotlight = spotlightCountries.value;
    // A region has no map geometry, so its aggregated ribbon can't be drawn as
    // an arc - expand it back into one arc per country in that region (the
    // same countries the aggregate summed, i.e. excluding individually picked ones).
    const expandRegions = (links, rows, partnerKey, selectedCountries) => links.flatMap(l => {
      if (!l._isRegion) return [l];
      const region = l[partnerKey];
      return rows.filter(r => regionMap[r[partnerKey]] === region && !selectedCountries.includes(r[partnerKey]));
    });
    const mapImports = expandRegions(topImports, importSankeyData.value, 'from', selImpCountries);
    const mapExports = expandRegions(topExports, allExports, 'to', selExpCountries);
    const mapLinks = [
      ...mapImports.map(l => ({ from: l.from, to: selectedCountryLabel.value, flow: l.flow, units: l.units, raw: l, side: 'import' })),
      ...mapExports.map(l => ({ from: selectedCountryLabel.value, to: l.to, flow: l.flow, units: l.units, raw: l, side: 'export' })),
    ];
    const world = await loadWorldMap();
    // A redraw (filter change, resize) may have been requested while the map
    // data was loading - bail if this call is no longer the latest.
    if (chartView.value !== 'map' || svgRef.value !== svgEl) return;
    drawFlowMap(svgEl, world, mapLinks, {
      centerName: selectedCountryLabel.value,
      widthScale: mapArcScale.value,
      colorOf: mapColorOf,
      isDimmed: name => spotlight.length > 0 && !spotlight.includes(name),
      onHover: (ev, link) => {
        const line1 = link.side === 'import'
          ? `${link.from} → ${selectedCountryLabel.value}: ${Number(link.flow).toLocaleString('en', { maximumFractionDigits: 1 })}${link.units ? ' ' + link.units : ''}`
          : `${selectedCountryLabel.value} → ${link.to}: ${Number(link.flow).toLocaleString('en', { maximumFractionDigits: 1 })}${link.units ? ' ' + link.units : ''}`;
        const line2 = unitValueLine(link.raw || {});
        showTooltip(ev, line1, line2);
      },
      // Country pin: its trades among the flows currently drawn (i.e. filtered)
      onPinHover: (ev, summary) => showTooltipLines(ev, pinTooltipLines(summary)),
      onMove: moveTooltip,
      onLeave: hideTooltip,
    });
    return;
  }

  if (!topImports.length && !topExports.length) return;

  const scaledImports = topImports.map(l => ({ ...l, value: Number(l.flow) || 0 }));
  const scaledExports = topExports.map(l => ({ ...l, value: Number(l.flow) || 0 }));

  const countryNode = selectedCountryLabel.value;
  const partnerColor = name => partnerColorMap[name] ?? '#9dabaf';

  // ── Layout constants ─────────────────────────────────────────────────────────
  const W  = svgEl.clientWidth  || 900;
  const H  = svgEl.clientHeight || 500;
  const onlyImports = topImports.length > 0 && topExports.length === 0;
  const onlyExports = topExports.length > 0 && topImports.length === 0;
  const cy = H / 2;
  const NODE_W   = 8;                  // node bar width
  const LEFT_X   = 180;               // x of left node bars (right edge)
  const RIGHT_X  = W - 180;           // x of right node bars (left edge)
  const V_PAD    = 16;                 // vertical padding top/bottom
  const GAP      = 3;                  // gap between nodes
  const availableH = H - V_PAD * 2;
  // Centre circle radius - large enough that each hemisphere's arc can hold
  // the ribbons at (close to) the full height they have at their nodes.
  const R = Math.max(40, Math.min(availableH * 0.3, (RIGHT_X - LEFT_X) * 0.15));
  // With only one side loaded, the circle moves to the empty side's edge so
  // that side's ribbons use the full width.
  const CIRCLE_EDGE = 30;
  const cx = onlyImports ? W - CIRCLE_EDGE - R : onlyExports ? CIRCLE_EDGE + R : W / 2;
  const ARC_SPAN = Math.PI * 0.9;      // arc each side's ribbons may use

  // ── Ribbon scale ──────────────────────────────────────────────────────────────
  // A ribbon is the same width along its whole length: its node height and its
  // slice of the circle (as arc length) are both max(MIN_W, value × k). In
  // linear mode k is shared - the largest scale at which the busier side still
  // fits both its node column (with gaps) and its hemisphere of the circle, so
  // the two sides stay comparable too (normalised: see ribbonScales). MIN_W keeps tiny flows visible; room for it is reserved
  // up front (max(MIN_W, v·k) ≤ MIN_W + v·k), so the column still fits.
  const MIN_W = 1.5;
  const sideScale = items => {
    const total = items.reduce((s, l) => s + l.value, 0);
    if (!total) return Infinity;
    const reserve = MIN_W * items.length;
    return Math.min(
      (availableH - GAP * Math.max(0, items.length - 1) - reserve) / total,
      (ARC_SPAN * R - reserve) / total,
    );
  };
  const [kImports, kExports] = ribbonScales(scaledImports, scaledExports, sideScale, normalised.value);

  // ── Distribute nodes vertically (each column centred on the circle) ───────────
  function layoutNodes(items, k) {
    const ribbonW = v => Math.max(MIN_W, v * k);
    const colH = items.reduce((s, l) => s + ribbonW(l.value), 0) + GAP * Math.max(0, items.length - 1);
    let y = cy - colH / 2;
    return items.map(l => {
      const h = ribbonW(l.value);
      const node = { ...l, y0: y, y1: y + h, yc: y + h / 2 };
      y += h + GAP;
      return node;
    });
  }

  const importNodes = layoutNodes(scaledImports, kImports);
  const exportNodes = layoutNodes(scaledExports, kExports);

  // ── Allocate circle arc segments ──────────────────────────────────────────────
  // Each ribbon's arc length equals its node height (value × k), stacked in node
  // order and centred on its side of the circle - top node to the top of the
  // arc, so ribbons never cross. a0 is always the upper end of the slice.
  // Imports: left hemisphere, centred on π (angles decrease going down).
  // Exports: right hemisphere, centred on 0 (angles increase going down).
  function arcSegments(nodes, centerAngle, downward) {
    const dThetas = nodes.map(n => (n.y1 - n.y0) / R);
    const total = dThetas.reduce((s, t) => s + t, 0);
    let a = centerAngle - downward * total / 2;
    return nodes.map((n, i) => {
      const a0 = a, a1 = a + downward * dThetas[i];
      a = a1;
      return { a0, a1, am: (a0 + a1) / 2 };
    });
  }

  const importArcs = arcSegments(importNodes, Math.PI, -1);
  const exportArcs = arcSegments(exportNodes, 0, 1);

  // ── Clear & setup SVG ─────────────────────────────────────────────────────────
  d3.select(svgEl).selectAll('*').remove();
  const svg = d3.select(svgEl);
  const defs = svg.append('defs');

  // ── Helper: tapered filled ribbon path ───────────────────────────────────────
  // Draws a filled bezier shape from a vertical node bar segment to an arc on the circle.
  function ribbonPath(nodeX, nodeY0, nodeY1, arcA0, arcA1, side) {
    // Points on node bar
    const nx0 = nodeX;
    const nx1 = nodeX + (side === 'left' ? NODE_W : -NODE_W);
    const ny0 = nodeY0;
    const ny1 = nodeY1;
    // Points on circle
    const cx0 = cx + R * Math.cos(arcA0);
    const cy0 = cy + R * Math.sin(arcA0);
    const cx1 = cx + R * Math.cos(arcA1);
    const cy1 = cy + R * Math.sin(arcA1);
    // Control points — pull toward horizontal centre
    const mx = cx + (side === 'left' ? -R * 0.1 : R * 0.1);
    const p = d3.path();
    // Top edge: node → circle (arc a0)
    p.moveTo(nx1, ny0);
    p.bezierCurveTo(mx, ny0, mx, cy0, cx0, cy0);
    // Arc on circle from a0 → a1
    p.arc(cx, cy, R, arcA0, arcA1, arcA1 < arcA0);
    // Bottom edge: circle (arc a1) → node
    p.bezierCurveTo(mx, cy1, mx, ny1, nx1, ny1);
    // Close along node bar
    p.lineTo(nx0, ny1);
    p.lineTo(nx0, ny0);
    p.closePath();
    return p.toString();
  }

  const spotlight = spotlightCountries.value;  // array; empty = no spotlight

  // ── Draw import ribbons ───────────────────────────────────────────────────────
  importNodes.forEach((node, i) => {
    const arc      = importArcs[i];
    const col      = partnerColor(node.from);
    const gradId   = `ig-${i}`;
    const dimmed   = spotlight.length > 0 && !spotlight.includes(node.from);
    const grad = defs.append('linearGradient')
      .attr('id', gradId).attr('gradientUnits', 'userSpaceOnUse')
      .attr('x1', LEFT_X).attr('x2', cx - R);
    grad.append('stop').attr('offset', '0%').attr('stop-color', col).attr('stop-opacity', dimmed ? 0.08 : 0.9);
    grad.append('stop').attr('offset', '100%').attr('stop-color', col).attr('stop-opacity', dimmed ? 0.03 : 0.25);

    svg.append('path')
      .attr('d', ribbonPath(LEFT_X, node.y0, node.y1, arc.a0, arc.a1, 'left'))
      .attr('fill', `url(#${gradId})`)
      .attr('stroke', 'none')
      .on('mouseenter', function(event) {
        if (!dimmed) d3.select(this).attr('fill-opacity', 1);
        const line1 = `${node.from} → ${countryNode}: ${Number(node.flow).toLocaleString('en', { maximumFractionDigits: 1 })}${node.units ? ' ' + node.units : ''}`;
        const line2 = unitValueLine(node);
        showTooltip(event, line1, line2);
      })
      .on('mousemove', moveTooltip)
      .on('mouseleave', function() {
        d3.select(this).attr('fill-opacity', null);
        hideTooltip();
      });
  });

  // ── Draw export ribbons ───────────────────────────────────────────────────────
  exportNodes.forEach((node, i) => {
    const arc    = exportArcs[i];
    const col    = partnerColor(node.to);
    const gradId = `eg-${i}`;
    const dimmed = spotlight.length > 0 && !spotlight.includes(node.to);
    const grad = defs.append('linearGradient')
      .attr('id', gradId).attr('gradientUnits', 'userSpaceOnUse')
      .attr('x1', cx + R).attr('x2', RIGHT_X);
    grad.append('stop').attr('offset', '0%').attr('stop-color', col).attr('stop-opacity', dimmed ? 0.03 : 0.25);
    grad.append('stop').attr('offset', '100%').attr('stop-color', col).attr('stop-opacity', dimmed ? 0.08 : 0.9);

    svg.append('path')
      .attr('d', ribbonPath(RIGHT_X, node.y0, node.y1, arc.a0, arc.a1, 'right'))
      .attr('fill', `url(#${gradId})`)
      .attr('stroke', 'none')
      .on('mouseenter', function(event) {
        if (!dimmed) d3.select(this).attr('fill-opacity', 1);
        const line1 = `${countryNode} → ${node.to}: ${Number(node.flow).toLocaleString('en', { maximumFractionDigits: 1 })}${node.units ? ' ' + node.units : ''}`;
        const line2 = unitValueLine(node);
        showTooltip(event, line1, line2);
      })
      .on('mousemove', moveTooltip)
      .on('mouseleave', function() {
        d3.select(this).attr('fill-opacity', null);
        hideTooltip();
      });
  });

  // ── Centre circle ─────────────────────────────────────────────────────────────
  // Outer glow ring
  svg.append('circle').attr('cx', cx).attr('cy', cy).attr('r', R + 6)
    .attr('fill', 'none').attr('stroke', '#e8ecff').attr('stroke-width', 12);
  // White fill
  svg.append('circle').attr('cx', cx).attr('cy', cy).attr('r', R)
    .attr('fill', '#ffffff').attr('stroke', '#e8ecff').attr('stroke-width', 1.5);
  // Country label
  svg.append('text').attr('x', cx).attr('y', cy - 8)
    .attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
    .attr('font-size', '14px').attr('font-weight', '700')
    .attr('fill', '#192e40').attr('font-family', 'system-ui, sans-serif')
    .text(countryNode);
  // Year label
  const yr = new Date(searchYear.value).getFullYear();
  svg.append('text').attr('x', cx).attr('y', cy + 12)
    .attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
    .attr('font-size', '11px').attr('fill', '#9dabaf').attr('font-family', 'system-ui, sans-serif')
    .text(yr);

  // ── Node bars & labels ────────────────────────────────────────────────────────
  // Labels are spread so small neighbouring partners never overlap; a label
  // pushed off its node gets a short connector back to it.
  const fmtFlow = (v) => Number(v).toLocaleString('en', { maximumFractionDigits: 1 });
  const drawSide = (nodes, side, nameKey) => {
    const labels = nodes.map(node => {
      const twoLine = node.y1 - node.y0 >= 24; // only show value if node is tall enough
      return { node, twoLine, y: node.yc, h: twoLine ? 26 : 13 };
    });
    spreadLabels(labels, V_PAD, H - V_PAD);
    labels.forEach(({ node, twoLine, ly }) => {
      const name = node[nameKey];
      const col = partnerColor(name);
      const dimmed = spotlight.length > 0 && !spotlight.includes(name);
      svg.append('rect')
        .attr('x', side === 'left' ? LEFT_X : RIGHT_X - NODE_W).attr('y', node.y0)
        .attr('width', NODE_W).attr('height', Math.max(1.5, node.y1 - node.y0))
        .attr('fill', col).attr('rx', 2).attr('fill-opacity', dimmed ? 0.15 : 1);
      drawPartnerLabel(svg, {
        side, edgeX: side === 'left' ? LEFT_X : RIGHT_X, yc: node.yc, ly, name,
        value: `${fmtFlow(node.flow)}${node.units ? ' ' + node.units : ''}`, twoLine,
        labelColor: dimmed ? '#c0c8d0' : '#192e40',
        valueColor: dimmed ? '#d0d8df' : '#213CE5',
      });
    });
  };
  drawSide(importNodes, 'left', 'from');
  drawSide(exportNodes, 'right', 'to');
}

// ── Classic / Sankey view ─────────────────────────────────────────────────────
// Three columns: import partners → the selected country (hub) → export
// partners. Laid out by hand: each ribbon is exactly as wide at its partner as
// at the hub. In linear mode ONE scale (k) is shared by every node, hub slice
// and ribbon, so a ribbon's width is its flow; in normalised mode the smaller
// side is stretched to the bigger side's height (see ribbonScales). The hub is
// as tall as the bigger side's total; the smaller side's slices are centred on it.
function drawSankeyD3Chart(svgEl, topImports, topExports, colorMap = {}, normalise = false) {
  const partnerColor = name => colorMap[name] ?? '#9dabaf';
  const W = svgEl.clientWidth  || 900;
  const H = svgEl.clientHeight || 520;
  const LABEL = 130;      // room reserved for partner labels on each side
  const PAD_V = 30;
  const NODE_W = 14;

  d3.select(svgEl).selectAll('*').remove();
  const svg  = d3.select(svgEl);
  const defs = svg.append('defs');

  const countryName = selectedCountryLabel.value;
  const valueOf = f => Math.max(Number(f) || 0, 0.0001);

  const imports = topImports.map(l => ({ raw: l, side: 'import', name: l.from, value: valueOf(l.flow) }));
  const exports = topExports.map(l => ({ raw: l, side: 'export', name: l.to, value: valueOf(l.flow) }));
  if (!imports.length && !exports.length) return;

  const spotlight = spotlightCountries.value;  // array; empty = no spotlight
  const isDimmed = name => spotlight.length > 0 && !spotlight.includes(name);

  // Once a side has more than 10 partners, use a small fixed gap; below that,
  // a more generous one so a short column still breathes.
  const sideCount = Math.max(imports.length, exports.length, 1);
  const GAP = sideCount > 10 ? 4 : 8;
  const plotH = H - PAD_V * 2;

  // Largest scale at which the busier side's column (nodes + gaps) still fits.
  // Every ribbon is at least MIN_W wide so tiny flows stay visible; room for
  // that is reserved up front (max(MIN_W, v·k) ≤ MIN_W + v·k), so it still fits.
  const MIN_W = 1.5;
  const sideTotal = items => items.reduce((s, l) => s + l.value, 0);
  const sideScale = items => sideTotal(items)
    ? (plotH - GAP * Math.max(0, items.length - 1) - MIN_W * items.length) / sideTotal(items)
    : Infinity;
  const [kImports, kExports] = ribbonScales(imports, exports, sideScale, normalise);
  imports.forEach(it => { it.w = Math.max(MIN_W, it.value * kImports); });
  exports.forEach(it => { it.w = Math.max(MIN_W, it.value * kExports); });
  const sideWidth = items => items.reduce((s, it) => s + it.w, 0);

  const importX0 = LABEL, importX1 = LABEL + NODE_W;
  const exportX0 = W - LABEL - NODE_W, exportX1 = W - LABEL;
  // With only one side loaded, the hub moves to the empty side's edge so that
  // side's ribbons use the full width (its label sits inside the bar, so it
  // needs no label margin).
  const HUB_EDGE = 30;
  const hubX0 = !exports.length ? W - HUB_EDGE - NODE_W
    : !imports.length ? HUB_EDGE
    : W / 2 - NODE_W / 2;
  const hubX1 = hubX0 + NODE_W;
  const midY = PAD_V + plotH / 2;

  // Partner columns: stacked with gaps, centred vertically.
  const stack = (items) => {
    const colH = sideWidth(items) + GAP * Math.max(0, items.length - 1);
    let y = midY - colH / 2;
    items.forEach(it => {
      it.y0 = y; it.y1 = y + it.w; it.yc = (it.y0 + it.y1) / 2;
      y = it.y1 + GAP;
    });
  };
  stack(imports);
  stack(exports);

  // Hub: as tall as the bigger side; each side's slices stacked without gaps,
  // centred on it, in the same order as that side's partners (no crossings).
  const hubH = Math.max(sideWidth(imports), sideWidth(exports));
  const hubY0 = midY - hubH / 2;
  [imports, exports].forEach(items => {
    let y = midY - sideWidth(items) / 2;
    items.forEach(it => { it.hubY0 = y; it.hubY1 = y + it.w; y = it.hubY1; });
  });

  // Constant-width ribbon: both ends are it.w tall, joined by two
  // horizontal-tangent curves.
  function band(x0, y0a, y0b, x1, y1a, y1b) {
    const mx = (x0 + x1) / 2;
    const p = d3.path();
    p.moveTo(x0, y0a);
    p.bezierCurveTo(mx, y0a, mx, y1a, x1, y1a);
    p.lineTo(x1, y1b);
    p.bezierCurveTo(mx, y1b, mx, y0b, x0, y0b);
    p.closePath();
    return p.toString();
  }

  // ── Links ──────────────────────────────────────────────────────────────────
  [...imports, ...exports].forEach((it, i) => {
    const isImport = it.side === 'import';
    const dimmed = isDimmed(it.name);
    const col = partnerColor(it.name);
    const gradId = `skg-${i}`;
    const nodeX = isImport ? importX1 : exportX0;
    const hubX  = isImport ? hubX0 : hubX1;
    const grad = defs.append('linearGradient').attr('id', gradId).attr('gradientUnits', 'userSpaceOnUse')
      .attr('x1', nodeX).attr('x2', hubX);
    const [baseC0, baseC1] = isImport ? [0.85, 0.25] : [0.25, 0.85];
    const [c0, c1] = dimmed ? [baseC0 * 0.15, baseC1 * 0.15] : [baseC0, baseC1];
    grad.append('stop').attr('offset', '0%').attr('stop-color', col).attr('stop-opacity', c0);
    grad.append('stop').attr('offset', '100%').attr('stop-color', col).attr('stop-opacity', c1);

    const raw = it.raw;
    const line1 = isImport
      ? `${raw.from} → ${countryName}: ${Number(raw.flow).toLocaleString('en', { maximumFractionDigits: 1 })}${raw.units ? ' ' + raw.units : ''}`
      : `${countryName} → ${raw.to}: ${Number(raw.flow).toLocaleString('en', { maximumFractionDigits: 1 })}${raw.units ? ' ' + raw.units : ''}`;
    const line2 = unitValueLine(raw);

    svg.append('path')
      .attr('d', band(nodeX, it.y0, it.y1, hubX, it.hubY0, it.hubY1))
      .attr('fill', `url(#${gradId})`)
      .attr('stroke', 'none')
      .attr('fill-opacity', dimmed ? 0.35 : 0.9)
      .on('mouseenter', function(ev) { if (!dimmed) d3.select(this).attr('fill-opacity', 1); showTooltip(ev, line1, line2); })
      .on('mousemove', moveTooltip)
      .on('mouseleave', function() { d3.select(this).attr('fill-opacity', dimmed ? 0.35 : 0.9); hideTooltip(); });
  });

  // ── Hub ────────────────────────────────────────────────────────────────────
  svg.append('rect')
    .attr('x', hubX0).attr('y', hubY0)
    .attr('width', NODE_W).attr('height', Math.max(2, hubH))
    .attr('fill', '#213CE5').attr('rx', 2);
  const hubCx = (hubX0 + hubX1) / 2;
  svg.append('text')
    .attr('x', hubCx).attr('y', midY)
    .attr('text-anchor', 'middle').attr('dominant-baseline', 'middle')
    .attr('transform', `rotate(-90, ${hubCx}, ${midY})`)
    .attr('font-size', '11px').attr('font-weight', '700').attr('fill', '#fff')
    .attr('font-family', 'system-ui, sans-serif')
    .text(countryName);

  // ── Partner nodes + spread labels ───────────────────────────────────────────
  const drawColumn = (items, side) => {
    const labels = items.map(it => ({ it, y: it.yc, h: 13 }));
    spreadLabels(labels, PAD_V, H - PAD_V);
    labels.forEach(({ it, ly }) => {
      const dimmed = isDimmed(it.name);
      svg.append('rect')
        .attr('x', side === 'left' ? importX0 : exportX0).attr('y', it.y0)
        .attr('width', NODE_W).attr('height', Math.max(1.5, it.y1 - it.y0))
        .attr('fill', partnerColor(it.name)).attr('rx', 2)
        .attr('fill-opacity', dimmed ? 0.25 : 1);
      drawPartnerLabel(svg, {
        side, edgeX: side === 'left' ? importX0 : exportX1, yc: it.yc, ly, name: it.name,
        twoLine: false, labelColor: dimmed ? '#c0c8d0' : '#192e40',
      });
    });
  };
  drawColumn(imports, 'left');
  drawColumn(exports, 'right');

  // Column headers
  if (imports.length) {
    svg.append('text').attr('x', LABEL + NODE_W / 2).attr('y', PAD_V - 12)
      .attr('text-anchor', 'middle').attr('font-size', '11px').attr('fill', '#000')
      .attr('font-family', 'system-ui, sans-serif').text('Imports');
  }
  if (exports.length) {
    svg.append('text').attr('x', W - LABEL - NODE_W / 2).attr('y', PAD_V - 12)
      .attr('text-anchor', 'middle').attr('font-size', '11px').attr('fill', '#000')
      .attr('font-family', 'system-ui, sans-serif').text('Exports');
  }
}

// ── Unit values ───────────────────────────────────────────────────────────────
// A ribbon that combines several partners (a region total, or the "Other …"
// bucket) gets the volume-weighted average unit value of the partners that
// report one, flagged so its tooltip reads "Avg unit value" rather than
// passing it off as a single reported price. {} when none report one.
function combinedUnitValue(rows) {
  let weighted = 0, volume = 0, units;
  for (const r of rows) {
    if (r.unitValue == null || !r.flow) continue;
    weighted += Number(r.unitValue) * r.flow;
    volume += r.flow;
    units ??= r.unitValueUnits;
  }
  return volume ? { unitValue: weighted / volume, unitValueUnits: units, unitValueAveraged: true } : {};
}

// Tooltip line for a ribbon's unit value, or null when it has none.
function unitValueLine(item) {
  if (item.unitValue == null) return null;
  const label = item.unitValueAveraged ? 'Avg unit value' : 'Unit value';
  return `${label}: ${Number(item.unitValue).toLocaleString('en', { maximumFractionDigits: 2 })}${item.unitValueUnits ? ' ' + item.unitValueUnits : ''}`;
}

// ── Tooltip helpers ────────────────────────────────────────────────────────────
let _tooltip = null;
function getTooltip() {
  if (!_tooltip) {
    _tooltip = document.createElement('div');
    _tooltip.style.cssText = `
      position: fixed; pointer-events: none; z-index: 9999; display: none;
      background: #192e40; color: #fff; font-size: 12px; border-radius: 6px;
      padding: 6px 10px; border: 1px solid #213ce5; white-space: nowrap;
    `;
    document.body.appendChild(_tooltip);
  }
  return _tooltip;
}

function showTooltip(event, line1, line2) {

  const t = getTooltip();
  t.innerHTML = '';
  const d1 = document.createElement('div');
  d1.textContent = line1;
  t.appendChild(d1);
  if (line2) {
    const d2 = document.createElement('div');
    d2.textContent = line2;
    d2.style.cssText = 'opacity:0.65; font-size:11px; margin-top:2px;';
    t.appendChild(d2);
  }
  t.style.display = 'block';
  moveTooltip(event);
}
// Multi-line tooltip ({ title, lines } from pinTooltipLines) - bold title,
// partner rows indented and faded like showTooltip's second line.
function showTooltipLines(event, { title, lines }) {
  const t = getTooltip();
  t.innerHTML = '';
  const head = document.createElement('div');
  head.textContent = title;
  head.style.fontWeight = '600';
  t.appendChild(head);
  lines.forEach(({ text, sub }) => {
    const d = document.createElement('div');
    d.textContent = text;
    if (sub) d.style.cssText = 'opacity:0.65; font-size:11px; padding-left:8px;';
    else d.style.marginTop = '3px';
    t.appendChild(d);
  });
  t.style.display = 'block';
  moveTooltip(event);
}
function moveTooltip(event) {
  const t = getTooltip();
  const EDGE = 4;
  const w = t.offsetWidth, h = t.offsetHeight;
  // Flip to the cursor's other side rather than run off the viewport edge.
  let x = event.clientX + 12, y = event.clientY - 28;
  if (x + w > window.innerWidth - EDGE)  x = event.clientX - 12 - w;
  if (y + h > window.innerHeight - EDGE) y = event.clientY - 12 - h;
  t.style.left = Math.max(EDGE, x) + 'px';
  t.style.top  = Math.max(EDGE, y) + 'px';
}
function hideTooltip() {
  getTooltip().style.display = 'none';
}

onMounted(async () => {

  // Load country → region map once for the Trade Flow region filters
  getCountryRegionMap().then(map => { countryRegionMap.value = map; });
  // Redraw the Sankey on window resize / zoom so the chart always fills the container
  const onWindowResize = () => {
    if (activeTab.value === 'Trade Flow') {
      updateViewportChartHeight();
      if (importSankeyData.value.length || exportSankeyData.value.length) {
        nextTick(() => drawSankeyChart());
      }
    }
  };
  window.addEventListener('resize', onWindowResize);
  // Capture phase, so a component that stops propagation (Naive UI inputs,
  // chart handlers) can't swallow the outside click before it reaches us.
  document.addEventListener('pointerdown', onDocMouseDown, true);
  // Store for cleanup
  _resizeObserver = { disconnect: () => {
    window.removeEventListener('resize', onWindowResize);
    document.removeEventListener('pointerdown', onDocMouseDown, true);
  }};
  isLoading.value = false;

  // FILTERS.PRODUCT = sessionStorage.getItem("productSupply");
  // FILTERS.COUNTRY = JSON.parse(sessionStorage.getItem("countries"));
  // Country Data's commodity filter should always start empty on entry rather
  // than restoring the last-used value - it must not carry over between visits.
  FILTERS.ELEMENT = null;

  FILTERS.COUNTRY = sessionStorage.getItem("countrySupply");
  FILTERS.PRODUCT = null;

  if (!FILTERS.COUNTRY || FILTERS.COUNTRY == "All") {
    FILTERS.COUNTRY = ["All"];
  }

  if (Array.isArray(FILTERS.COUNTRY)) {
    loadAll.value = true;
  }
  displayType.value = localStorage.getItem("displayTypeSupply") ?? "Table";

  await initializeFilters(FILTERS.ELEMENT);

  if (loadAll.value) {
    yearsView.value = [
      new Date(minFilterYear.value, 0).getTime(),
      new Date(maxFilterYear.value, 0).getTime(),
    ];
  }

  await getTableData();
  isMounted = true;
});

watch(() => SUBSCRIPTION_INFO?.dataElements, (newVal) => {
  if (!newVal?.length) return;
  // Leave the filter empty on initial load - only auto-correct it here if the
  // user had a commodity selected that's no longer in their subscribed list.
  if (FILTERS.ELEMENT && !newVal.some(nth => nth.code === FILTERS.ELEMENT)) {
    FILTERS.ELEMENT = newVal[0].code;
    getTableData();
  }
});

watch(
    () => FILTERS.ELEMENT,
    async (newVal) => {
      await Promise.all([
        getCommodityProductsAndCountries(newVal, activeTab.value),
        refreshTradeFlowYearCountries(),
      ]);
      if (activeTab.value === 'Trade Flow') clearCountryIfUnavailable();
      FILTERS.PRODUCT = null;
      countryData.value = [];
      needsRefresh.value = true;

      // Only pull the selected range in if it now falls outside what this
      // commodity actually has; otherwise leave the user's selection alone.
      const currentStart = new Date(yearsView.value[0]).getFullYear();
      const currentEnd = new Date(yearsView.value[1]).getFullYear();
      yearsView.value = [
        new Date(Math.min(Math.max(currentStart, minFilterYear.value), maxFilterYear.value), 0).getTime(),
        new Date(Math.max(Math.min(currentEnd, maxFilterYear.value), minFilterYear.value), 0).getTime(),
      ];

      if (!newVal) {
        getTableData();
      }

      showToast.value = true;
      setTimeout(() => {
        showToast.value = false;
      }, 4000);
    }
  );

// The Trade Flow country list only holds countries that appear (as reporter or
// trade partner) in Trade_Flow rows - a country carried over from another tab
// or commodity that isn't in it (e.g. "EU" from Supply) is cleared rather
// than left selected with nothing behind it.
function clearCountryIfUnavailable() {
  if (FILTERS.COUNTRY && !COUNTRY_OPTS.value.some(c => c.value === FILTERS.COUNTRY)) {
    FILTERS.COUNTRY = null;
  }
}

// A different year can have a different set of trading countries
watch(searchYear, async () => {
  if (activeTab.value !== 'Trade Flow') return;
  await refreshTradeFlowYearCountries();
  clearCountryIfUnavailable();
});

watch(activeTab, async (tab, prevTab) => {
  expandedRowKeys.value = [];

  if (activeTab.value !== "Trade Flow") {
    // Back from Trade Flow - restore the Supply/Trade tabs' own saved country
    if (prevTab === "Trade Flow") FILTERS.COUNTRY = sessionStorage.getItem("countrySupply") || null;
    countryData.value = [];
    if (svgRef.value) d3.select(svgRef.value).selectAll('*').remove();
    return;
  }

  // Refresh the country list against Trade Flow data specifically - the Supply/Trade
  // tabs' country codes don't necessarily overlap with what Trade_Flow rows have.
  await Promise.all([
    getCommodityProductsAndCountries(FILTERS.ELEMENT, activeTab.value),
    refreshTradeFlowYearCountries(),
  ]);
  // Restore this tab's own saved country; first visit carries the current
  // country over if Trade Flow has data for it.
  FILTERS.COUNTRY = sessionStorage.getItem("countryTradeFlow") ?? FILTERS.COUNTRY;
  clearCountryIfUnavailable();

  // Populate HS code dropdowns from uploaded trade flow data when the tab is opened
  await refreshHsCodes();
  await nextTick();
  updateViewportChartHeight();
  await nextTick();
  drawSankeyChart();
});

const tableData = computed(() => {

  const data = countryData.value || [];
  // Build years dynamically from all records
  const allYears = new Set();

  data.forEach(e => {
    Object.keys(e.yearlyData || {}).forEach(y => allYears.add(Number(y)));
  });

  const years = Array.from(allYears).sort((a, b) => a - b);

  lastYearStart.value = years[0] || 2015;
  lastYearEnd.value = years[years.length - 1] || 2035;

  // GROUP BY ELEMENT
  const grouped = {};

  data.forEach(item => {
    if (!grouped[item.elementCode]) {
      grouped[item.elementCode] = {
        key: `element-${item.elementCode}`,
        level: "Element",
        elementCode: item.elementCode,
        productCode: "",
        yearlyData: {},
        children: []
      };
    }

    const elementNode = grouped[item.elementCode];

    if (activeTab.value == "Supply") {
      // PRODUCT NODE
      item.products.forEach(product => {

        const productNode = {
          key: `product-${item.elementCode}-${product.productCode}`,
          level: "Product",
          elementCode: item.elementCode,
          productCode: product.productCode,
          units: product.units,
          yearlyData: product.yearlyData || {},
          children: []
        };

        product?.assets?.forEach(asset => {
          const assetNode = {
            key: `product-${item.elementCode}-${product.productCode}-${asset.assetName}`,
            level: "Asset",
            elementCode: item.elementCode,
            productCode: product.productCode,
            yearlyData: asset.yearlyData || {},
            assetName: asset.assetName
          };
          productNode.children.push(assetNode);
        });

        elementNode.children.push(productNode);
      });
    }
    else {
      const importNode = {
        key: `element-${item.elementCode}-IMPORT`,
        level: "Type",
        type: "IMPORT",
        elementCode: "",
        productCode: "Import",
        yearlyData: {},
        children: []
      };

      const exportNode = {
        key: `element-${item.elementCode}-EXPORT`,
        level: "Type",
        type: "EXPORT",
        elementCode: "",
        productCode: "Export",
        yearlyData: {},
        children: []
      };

      item.products.forEach(product => {
        const productNode = {
          key: `product-${item.elementCode}-${product.type}-${product.productCode}`,
          level: "Product",
          elementCode: "",
          productCode: product.productCode,
          units: product.units,
          yearlyData: product.yearlyData || {},
          children: []
        };

        if (product.type === "IMPORT") {
          importNode.children.push(productNode);
        } else if (product.type === "EXPORT") {
          exportNode.children.push(productNode);
        }
      });

      if (importNode.children.length) {
        elementNode.children.push(importNode);
      }

      if (exportNode.children.length) {
        elementNode.children.push(exportNode);
      }
    }
  });

  return Object.values(grouped);
});

const columns = computed(() => {

  const start = new Date(yearsView.value[0]).getFullYear()
  const end = new Date(yearsView.value[1]).getFullYear()

  const years = Array.from(
    { length: end - start + 1 },
    (_, i) => start + i
  );

  return [
    {
      title: "Element",
      key: "elementCode",
      width: 160,
      render(row) {
        return row.level === "Element" ? row.elementCode : '';
      }
    },

    {
      title: "Product",
      key: "productCode",
      width: 260,
      render(row) {
        const indent = row.level === "Asset" || row.level === "Asset-Header" ? 24 : 0;
        const label = row.level === "Product"
          ? row.productCode
          : row.level === "Asset" || row.level === 'Asset-Header'
            ? row.assetName
            : '';
        return label ? h('span', { style: { paddingLeft: `${indent}px`, whiteSpace: 'nowrap' } }, label) : '';
      }
    },
    {
      title: "Units",
      key: "units",
      width: 90,
      render(row) {
        return row.units ?? "";
      }
    },

    ...years.map(year => ({
      title: `${year}`,
      key: `${year}`,
      width: 110,
      align: "right",
      render(row) {
        if (row.level === 'Asset-Header') {
          return "";
        }
        const value = row.yearlyData?.[year];
        if (value == null) return "";

        return Number(value).toLocaleString("en", {
          minimumFractionDigits: decimals.value,
          maximumFractionDigits: decimals.value
        });
      }
    }))
  ];
});

const columnsTrade = computed(() => {

  const start = new Date(yearsView.value[0]).getFullYear()
  const end = new Date(yearsView.value[1]).getFullYear()

  const years = Array.from(
    { length: end - start + 1 },
    (_, i) => start + i
  );

  return [
    {
      title: "Element",
      key: "elementCode",
      width: 160,
      render(row) {
        if (row.level === "Element") return row.elementCode;
        if (row.level === "Type") return h('span', { style: { paddingLeft: '16px', whiteSpace: 'nowrap' } }, row.productCode);
        return '';
      }
    },
    {
      title: "Product",
      key: "productCode",
      width: 260,
      render(row) {
        let label = "";
        let indent = 0;
        if (row.level === "Product") {
          label = row.productCode;
        } else if (row.level === "Asset" || row.level === "Asset-Header") {
          label = row.assetName;
          indent = 24;
        }
        return label ? h('span', { style: { paddingLeft: `${indent}px`, whiteSpace: 'nowrap' } }, label) : '';
      }
    },
    {
      title: "Units",
      key: "units",
      width: 90,
      render(row) {
        return row.units ?? "";
      }
    },
    ...years.map(year => ({
      title: `${year}`,
      key: `${year}`,
      width: 110,
      align: "right",
      render(row) {
        if (row.level === 'Asset-Header') {
          return "";
        }
        const value = row.yearlyData?.[year];
        if (value == null) return "";

        return Number(value).toLocaleString("en", {
          minimumFractionDigits: decimals.value,
          maximumFractionDigits: decimals.value
        });
      }
    }))
  ];
});

const activeColumns = computed(() => activeTab.value === 'Trade' ? columnsTrade.value : columns.value);
const activeTableWidth = computed(() => activeTab.value === 'Trade' ? tableWidthTrade.value : tableWidth.value);

const rowKey = (row) => row.key;
const expandedRowKeys = ref([]);

// Helper to resolve row label for tree table expand/collapse logging
const getRowLabel = (key) => {
  if (!key) return 'Row';
  const searchTree = (nodes) => {
    for (const node of nodes) {
      if (node.key === key) return node;
      if (node.children?.length) {
        const found = searchTree(node.children);
        if (found) return found;
      }
    }
    return null;
  };
  const node = searchTree(tableData.value || []);
  if (node) {
    if (node.level === "Element") {
      const elOpt = ELEMENT_OPTS.value?.find(e => e.value === node.elementCode);
      return `Element: "${elOpt?.label || node.elementCode}"`;
    }
    if (node.level === "Product") return `Product: "${node.productCode}"`;
    if (node.level === "Asset") return `Asset: "${node.assetName || node.productCode}"`;
    if (node.level === "Type") return `Type: "${node.productCode || node.type}"`;
  }
  return `Row: "${key}"`;
};

// Track table row expand / collapse
watch(expandedRowKeys, (newKeys, oldKeys) => {
  if (!isMounted || isResettingExpanded) return;
  const oldSet = new Set(oldKeys || []);
  const newSet = new Set(newKeys || []);

  const added = (newKeys || []).filter(k => !oldSet.has(k));
  const removed = (oldKeys || []).filter(k => !newSet.has(k));

  if (added.length > 0) {
    const label = getRowLabel(added[0]);
    logUserAction(
      USER_ACTIONS.VIEW_DASHBOARD,
      `Expanded Country Focus table (${label}, Country: "${selectedCountryLabel.value}")`
    );
  } else if (removed.length > 0) {
    const label = getRowLabel(removed[0]);
    logUserAction(
      USER_ACTIONS.VIEW_DASHBOARD,
      `Collapsed Country Focus table (${label}, Country: "${selectedCountryLabel.value}")`
    );
  }
}, { deep: true });

const rowClassName = (row) => {
  if (row.level === "Element" || row.level === "Asset-Header") return "element-row";
  if (row.level === "Product") return "product-row";
  return "";
};

const menuOpen = ref(false)

const exportAs = (type) => {
  menuOpen.value = false
  if (type === 'svg') {
    downloadAsSvg();
  } else {
    downloadAsPng();
  }
}

const downloadAsSvg = () => {
  htmlToImage.toSvg(captureDiv.value)
    .then(dataUrl => {
      const link = document.createElement("a");
      link.download = "capture.svg";
      link.href = dataUrl;
      link.click();
      showOptions.value = false;
    });

}
const downloadAsPng = () => {
  htmlToImage.toPng(captureDiv.value)
    .then(dataUrl => {
      const link = document.createElement("a");
      link.download = "capture.png";
      link.href = dataUrl;
      link.click();
      showOptions.value = false;
    });
}

const minYear = computed(() => {
  if (!countryData.value) return null

  const allYears = countryData.value.flatMap(item => {
    let keys = Object.keys(item.products[0]?.yearlyData || {}).map(Number);
    return keys;
  });

  let minAllowedYears = countryData.value.map(x => x.startYear);
  let minYear = Math.min(...minAllowedYears.filter(y => y != null));

  let min = allYears.length ? Math.min(...allYears) : null;
  return minYear == 'Infinity' ? min : min > minYear ? min : minYear;
})

const maxYear = computed(() => {
  if (!countryData.value || countryData.value.length == 0) return null

  const allYears = countryData.value.flatMap(item => {
    let keys = Object.keys(item.products[0]?.yearlyData || {}).map(Number);
    return keys
  })

  let maxAllowedYears = countryData.value.map(x => x.endYear)
  let maxYear = Math.max(...maxAllowedYears.filter(y => y != null))

  let max = allYears.length ? Math.max(...allYears) : null

  return maxYear == '-Infinity' ? max : max > maxYear ? max : maxYear
})

// The real available year range for the currently selected commodity + tab
// (Supply/Trade), independent of whatever the user has the date picker
// narrowed to. `countries.value` is refetched via getCommodityProductsAndCountries
// every time FILTERS.ELEMENT or activeTab changes, so this stays accurate and
// fully dynamic per commodity/tab without needing to track/widen anything
// across searches.
const minFilterYear = computed(() => {
  const startYears = (countries.value ?? []).map(x => x.startYear).filter(y => y != null);
  return startYears.length ? Math.min(...startYears) : 2015;
});

const maxFilterYear = computed(() => {
  const endYears = (countries.value ?? []).map(x => x.endYear).filter(y => y != null);
  return endYears.length ? Math.max(...endYears) : 2035;
});

const disableOutOfRange = (timestamp) => {

  const year = new Date(timestamp).getFullYear();
  if (selectedCountryInfo.value) {
    return (
      year < selectedCountryInfo.value.startYear ||
      year > selectedCountryInfo.value.endYear
    );
  }

  return year < minFilterYear.value || year > maxFilterYear.value;
};

const isDisabled = computed(() => { return FILTERS?.COUNTRY == "" || FILTERS?.COUNTRY == undefined })

const getTableDataAll = async () => {
  FILTERS.COUNTRY = ["All"];
  getTableData();
}

let fetchSeq = 0;

const getTableData = async () => {
  needsRefresh.value = false;
  isResettingExpanded = true;
  expandedRowKeys.value = [];
  await nextTick();
  isResettingExpanded = false;

  if (activeTab.value == "Trade Flow") {
    return;
  }

  const startYearNum = new Date(yearsView.value[0]).getFullYear();
  const endYearNum = new Date(yearsView.value[1]).getFullYear();

  // Track search / refresh query execution
  logUserAction(
    USER_ACTIONS.SEARCH_DASHBOARD,
    `Searched Country Focus (${activeTab.value}): Country="${selectedCountryLabel.value}", Commodity="${FILTERS.ELEMENT || 'All'}", Years=${startYearNum}-${endYearNum}`
  );

  const seq = ++fetchSeq;
    await getCommodityProductsAndCountries(
      FILTERS.ELEMENT,
      activeTab.value
    );

  if (seq !== fetchSeq) return; // a newer request has since started; discard this one

  // Clamp the query window to what this commodity + tab actually has, so a
  // previously-picked range that's now out of bounds (e.g. a different tab
  // with a shorter data history) doesn't get sent to the API as-is.
  const clampedStart = Math.min(Math.max(new Date(yearsView.value[0]).getFullYear(), minFilterYear.value), maxFilterYear.value);
  const clampedEnd = Math.max(Math.min(new Date(yearsView.value[1]).getFullYear(), maxFilterYear.value), minFilterYear.value);
  yearsView.value = [
    new Date(clampedStart, 0).getTime(),
    new Date(clampedEnd, 0).getTime(),
  ];

    if (activeTab.value === "Supply") {

        await getCountryDataSupply(
            FILTERS.ELEMENT,
            FILTERS.PRODUCT,
            [FILTERS.COUNTRY],
            new Date(yearsView.value[0]).getFullYear(),
            new Date(yearsView.value[1]).getFullYear()
        );

    } else {

        await getCountryDataTrade(
            FILTERS.ELEMENT,
            FILTERS.PRODUCT,
            [FILTERS.COUNTRY],
            new Date(yearsView.value[0]).getFullYear(),
            new Date(yearsView.value[1]).getFullYear()
        );

    }

  if (seq !== fetchSeq) return;

  if (FILTERS.COUNTRY == "[All]" && !loadAll.value) {
    FILTERS.COUNTRY = null;
  }
  graphView.value = null;
  //countryData.value = null;

  _ = activeTab.value == 'Supply'
    ? await getCountryDataSupply(FILTERS.ELEMENT,
      FILTERS.PRODUCT,
      new Array(1).fill(FILTERS.COUNTRY),
      new Date(yearsView.value[0]).getFullYear(),
      new Date(yearsView.value[1]).getFullYear())
    : await getCountryDataTrade(FILTERS.ELEMENT,
      FILTERS.PRODUCT,
      new Array(1).fill(FILTERS.COUNTRY),
      new Date(yearsView.value[0]).getFullYear(),
      new Date(yearsView.value[1]).getFullYear());

  if (seq !== fetchSeq) return;

  dataTab.value = activeTab.value;

  await nextTick();

  tableWidth.value = ((columns.value.length - 3) * 110) + 510;
  tableWidthTrade.value = ((columnsTrade.value.length - 3) * 110) + 510;
  decimals.value = countryData.value[0]?.decimalPlaces ?? 1;
  isSearch.value = true;
}

const selectedCountryInfo = computed(() =>
  countries.value?.find(x => x.code === FILTERS.COUNTRY)
);

// Trade Flow year picker: like the Supply/Trade Start/End pickers, only years
// with data can be picked - the selected HS codes' Start/End Year, else the
// selected country's, else the whole commodity's (countries.value holds the
// Trade_Flow countries while this tab is open). A year outside it moves to the
// latest year with data.
const tradeFlowYearRange = computed(() => {
  if (activeTab.value !== 'Trade Flow') return null;
  const pickedCodes = [
    ...IMPORT_HS_CODE_OPTS.value.filter(o => o.value === importHsCode.value),
    ...EXPORT_HS_CODE_OPTS.value.filter(o => o.value === exportHsCode.value),
  ];
  if (pickedCodes.length) return tradeFlowYearSpan(pickedCodes);
  if (selectedCountryInfo.value) return tradeFlowYearSpan([selectedCountryInfo.value]);
  return tradeFlowYearSpan(countries.value);
});

const isTradeFlowYearOutOfRange = (ts) => {
  const r = tradeFlowYearRange.value;
  const year = new Date(ts).getFullYear();
  return !!r && (year < r.startYear || year > r.endYear);
};

watch(tradeFlowYearRange, (r) => {
  if (r && isTradeFlowYearOutOfRange(searchYear.value)) {
    searchYear.value = new Date(r.endYear, 0).getTime();
  }
});
watch(
  () => FILTERS.COUNTRY,
  (newVal) => {
    const country = countries.value?.find(x => x.code === newVal);
    if (!country) return;

     yearsView.value = [
        new Date(country.startYear ?? minYear.value, 0).getTime(),
        new Date(country.endYear ?? maxYear.value, 0).getTime()
    ];
  }
);

function checkCountryMatch(savedCountry) {
  if (!savedCountry) return;

  if (savedCountry === "All") {
    FILTERS.COUNTRY = ["All"];
    loadAll.value = true;
    showToast.value = false;
    return;
  }

  const matched = countries.value.find(x => x.code === savedCountry);

  if (matched) {
    FILTERS.COUNTRY = matched.code;
    showToast.value = false;

    yearsView.value = [
      new Date(matched.startYear ?? 2015, 0).getTime(),
      new Date(matched.endYear ?? 2035, 0).getTime()
    ];
  } else {
    FILTERS.COUNTRY = null;
    showToast.value = true;
  }
}

const initializeFilters = async (element) => {
  if (!element) return;

  await getCommodityProductsAndCountries(element, "Supply");

  checkCountryMatch(sessionStorage.getItem("countrySupply"));
};

// The Trade Flow tab keeps its own saved country: its country list (Trade_Flow
// reporters/partners) differs from Supply/Trade's, so sharing one would let
// either tab clear or overwrite the other's selection.
const countryStorageKey = () => activeTab.value === 'Trade Flow' ? 'countryTradeFlow' : 'countrySupply';

watch(() => FILTERS.COUNTRY, (newVal, oldVal) => {
  if (newVal) {
    sessionStorage.setItem(countryStorageKey(), newVal);
  } else {
    sessionStorage.removeItem(countryStorageKey());
  }
  if (!isMounted || newVal === oldVal) return;
  const label = COUNTRY_OPTS.value.find(nth => nth.value === newVal)?.label || newVal || "All";
  logUserActionDebounced(
    USER_ACTIONS.FILTER_DASHBOARD,
    `Selected Country Focus country: "${label}"`,
    400
  );
});

watch(() => FILTERS.ELEMENT, (newVal, oldVal) => {
  if (newVal) {
    sessionStorage.setItem("countrySupplyElement", newVal);
  } else {
    sessionStorage.removeItem("countrySupplyElement");
  }
  if (!isMounted || newVal === oldVal) return;
  const elOpt = ELEMENT_OPTS.value?.find(e => e.value === newVal);
  logUserActionDebounced(
    USER_ACTIONS.FILTER_DASHBOARD,
    `Selected Country Focus commodity: "${elOpt?.label || newVal || 'All'}" (Country: "${selectedCountryLabel.value}")`,
    400
  );
});

// Clean up resize observer and tooltip on unmount
onBeforeUnmount(() => {
  if (_resizeObserver) _resizeObserver.disconnect();
  if (_tooltip) { _tooltip.remove(); _tooltip = null; }
});

</script>

<style lang="scss">
// ── Trade Flow toolbar ────────────────────────────────────────────────────────
.tf-toolbar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
  min-height: 36px;
}

.tf-chart-container {
  position: relative;
  min-height: 420px;
  // Project Blue watermark, faded with the same 80% white overlay the other
  // market data charts use
  background:
    linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)),
    url('https://driqq8crwypb5.cloudfront.net/articles/projectblue-data-dash-image.png') center / 60% no-repeat,
    #ffffff;
  border-radius: 0;
  border: none;
  border-top: 1px solid #e0e3ef;
  overflow: hidden;
}

.tf-chart-canvas {
  position: relative;
  width: 100%;
}

// Map flow thickness: a bottom-right corner button; clicking it slides the
// slider out to its left, growing from the button (same as TradeFlowData)
.tf-arc-width {
  position: absolute;
  right: 10px;
  bottom: 10px;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'GilroyMedium', system-ui, sans-serif;
}
.tf-arc-width__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 1px solid #e0e3ef;
  border-radius: 3px;
  background: rgba(255,255,255,0.95);
  color: #5b6378;
  cursor: pointer;
  transition: all 0.15s;
  &:hover { border-color: #213CE5; color: #213CE5; }
  &.active { border-color: #213CE5; background: #213CE5; color: #fff; }
}
.tf-arc-width__panel {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #e0e3ef;
  border-radius: 3px;
  background: rgba(255,255,255,0.95);
  font-size: 12px;
  color: #5b6378;
  white-space: nowrap;
  transform-origin: right center;
  input[type='range'] {
    width: 140px;
    accent-color: #213CE5;
    cursor: pointer;
  }
}
.tf-arc-width__value {
  min-width: 34px;
  text-align: right;
  font-variant-numeric: tabular-nums;
  color: #000;
}
.tf-arc-width-slide-enter-active,
.tf-arc-width-slide-leave-active {
  transition: transform 0.22s ease, opacity 0.18s ease;
}
.tf-arc-width-slide-enter-from,
.tf-arc-width-slide-leave-to {
  opacity: 0;
  transform: translateX(19px) scaleX(0.1);
}

.tf-export-source {
  padding: 0 20px 4px;
}

.tf-view-toggle {
  display: flex;
  gap: 4px;
  align-items: center;
}
.tf-view-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  outline: none;
  background: transparent;
  color: #000;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;
  font-family: 'GilroyMedium', system-ui, sans-serif;
  &:hover { color: #213CE5; }
  &.active {
    color: #213CE5 !important;
    /* some imported base style adds a full border on .active - strip it back
       down to just the bottom border this component actually wants */
    border: none !important;
    border-bottom: 2px solid #213CE5 !important;
    background-color: transparent !important;
  }
}

.tf-log-toggle {
  flex-shrink: 0;
  .n-switch__checked,
  .n-switch__unchecked {
    display: flex !important;
    align-items: center !important;
  }
}

// â"€â"€ Toolbar centre group (Top N / Focus / Reset) â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€

.tf-toolbar-centre {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 6px;
  pointer-events: auto;
}

.tf-rail-btn--inline {
  flex-direction: row !important;
  padding: 4px 10px !important;
  gap: 5px !important;
  font-size: 11px !important;
  background: transparent !important;
  box-shadow: none !important;
  border-color: #c8cfe8 !important;
}

.tf-rail-badge--inline {
  position: static !important;
  top: unset !important;
  right: unset !important;
  margin-left: 2px;
}

// ── Radial filter rail ────────────────────────────────────────────────────────
.tf-filter-rail {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  z-index: 10;
}

.tf-filter-rail--left  { left: 10px; }
.tf-filter-rail--right { right: 10px; }

.tf-rail-divider {
  width: 32px;
  height: 1px;
  background: #e0e3ef;
  margin: 2px 0;
}

.tf-rail-btn {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  padding: 8px 10px;
  border: 1px solid #e0e3ef;
  border-radius: 3px;
  background: rgba(255,255,255,0.95);
  backdrop-filter: blur(6px);
  color: #000;
  font-size: 12px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  font-family: 'GilroyMedium', system-ui, sans-serif;
  &:hover { border-color: #213CE5; color: #213CE5; }
  &.active { border-color: #213CE5; color: #213CE5; background: rgba(33,60,229,0.06); }
  &.tf-rail-btn--reset {
    color: #c0392b;
    border-color: #f5c6c2;
    &:hover { border-color: #c0392b; background: rgba(192,57,43,0.05); }
  }
}
.tf-rail-badge {
  position: absolute;
  top: -5px; right: -5px;
  background: #213CE5;
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  border-radius: 8px;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 3px;
  line-height: 1;
}

// ── Filter overlay panel ──────────────────────────────────────────────────────
.tf-filter-panel {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  border: 1px solid #e0e3ef;
  border-radius: 3px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.10);
  padding: 10px 12px;
  z-index: 20;
  min-width: 190px;
  max-width: 240px;
}

// Import panel opens to the right of the left rail
.tf-filter-panel--left  { left: 62px; right: unset; }

// Export panel opens to the left of the right rail
.tf-filter-panel--right { right: 62px; left: unset; }

// Top N / Spotlight â€" opened from toolbar, centred under it

.tf-filter-panel--centre {
  left: 50%;
  right: unset;
  top: 12px;
  transform: translateX(-50%);
}

.tf-panel-title {
  font-size: 12px;
  font-weight: 600;
  color: #000;
  margin-bottom: 8px;
}
.tf-chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.tf-chip {
  padding: 3px 10px;
  border: 1px solid #e0e3ef;
  border-radius: 3px;
  font-size: 12px;
  font-weight: 400;
  color: #000;
  cursor: pointer;
  transition: all 0.13s;
  background: #fff;
  font-family: 'GilroyMedium', system-ui, sans-serif;
  &:hover { border-color: #213CE5; color: #213CE5; }
  &.active { background: #213CE5; border-color: #213CE5; color: #fff; }
}

.tf-region-group {
  margin-bottom: 2px;
}
.tf-region-header {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 5px 6px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #192e40;
  font-family: 'GilroyMedium', system-ui, sans-serif;
  border-radius: 3px;
  &:hover { background: #f3f5fb; }
}
.tf-region-chevron {
  flex-shrink: 0;
  color: #9dabaf;
  transition: transform 0.15s;
  &.tf-region-chevron--open { transform: rotate(90deg); }
}
.tf-region-name {
  flex: 1;
  text-align: left;
}
.tf-region-countries {
  padding-left: 18px;
}

.tf-search-input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px 8px;
  border: 1px solid #e0e3ef;
  border-radius: 0;
  font-size: 12px;
  outline: none;
  margin-bottom: 8px;
  color: #000;
  font-family: 'GilroyMedium', system-ui, sans-serif;
  &::placeholder { color: #b0bec5; }
  &:focus { border-color: #213CE5; }
}
.tf-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.tf-clear-link {
  border: none;
  background: none;
  color: #9dabaf;
  font-size: 12px;
  cursor: pointer;
  padding: 0;
  font-family: 'GilroyMedium', system-ui, sans-serif;
  &:hover { color: #c0392b; }
}
.tf-panel-hint {
  font-size: 12px !important;
  color: #000;
  margin: 0 0 8px;
}

// Multi-select country items with checkbox
.tf-country-item--check {
  display: flex;
  align-items: center;
  gap: 7px;
}
.tf-check-box {
  flex-shrink: 0;
  width: 14px; height: 14px;
  border: 1px solid #c8cfe8;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  transition: all 0.12s;
}
.tf-country-item--check.active .tf-check-box,
.tf-check-box--checked,
.tf-check-box--indeterminate {
  background: #213CE5;
  border-color: #213CE5;
}
.tf-country-item--check.active {
  background: none;
  color: #213CE5;
}

.tf-country-list {
  max-height: 180px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1px;
  margin: 0 -2px;
}
.tf-country-item {
  padding: 5px 8px;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
  color: #000;
  text-align: left;
  background: none;
  border: none;
  transition: background 0.1s;
  font-family: 'GilroyMedium', system-ui, sans-serif;
  &:hover { background: #f2f2f2; }
  &.active { background: #eef0ff; color: #213CE5; font-weight: 600; }
}

// Panel slide transition
.tf-panel-enter-active, .tf-panel-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

// Right panel slides in from right, left panel from left
.tf-filter-panel--right.tf-panel-enter-from,
.tf-filter-panel--right.tf-panel-leave-to { opacity: 0; transform: translateY(-50%) translateX(8px); }
.tf-filter-panel--left.tf-panel-enter-from,
.tf-filter-panel--left.tf-panel-leave-to  { opacity: 0; transform: translateY(-50%) translateX(-8px); }
.tf-filter-panel--centre.tf-panel-enter-from,
.tf-filter-panel--centre.tf-panel-leave-to { opacity: 0; transform: translateX(-50%) scale(0.97); }
#date-picker {
  .n-input {
    --n-border-hover: 1px solid rgb(224, 224, 230) !important;
    --n-border-focus: 1px solid rgb(224, 224, 230) !important;
  }
}

.n-date-panel-actions__suffix>.n-button {
  display: none !important;
}

p {
  font-size: 14px !important;
  line-height: 1.625 !important;
  font-weight: 400 !important;
}

.chart-legend li {
  text-transform: none !important;
  color: red !important;
}

.split-btn {
  display: inline-flex;
  border-radius: 3px;
  overflow: hidden;
  height: 34px;
}

.primary {
  background: #192e40;
  color: #fff;
  border: none;
  cursor: pointer;
  font-size: 14px;
}

.toggle {
  background: #e5e7eb;
  border: none;
  cursor: pointer;
}

.caret {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid currentColor;
}

.split-menu {
  position: absolute;
  margin-top: 6px;
  width: 110px;
  background: white;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  z-index: 1000;
}

.split-menu button {
  width: 100%;
  background: transparent;
  border: 0;
  text-align: left;
  cursor: pointer;
  font-size: 14px;
}

.split-menu button:hover {
  background: rgba(37, 99, 235, 0.08);
}

.active {
  background-color: white !important;
  /* secondary color */
  color: #192e40 !important;
  font-weight: bold;
  border: 1px solid #192e40 !important;
}

.input-wrapper {
  position: relative;
  /* anchor for absolute toast */
  width: 100%;
}

.p-toast {
  position: absolute;
  top: calc(100% - 110px);
  /* appear just under textbox */
  left: 0;

  background: #fff8e5;
  color: #5f4b00;
  border-left: 4px solid #f6c343;
  padding: 10px 14px;
  border-radius: 6px;
  font-size: 14px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  max-width: 100%;

  white-space: normal;
  z-index: 9999;

  opacity: 0;
  transform: translateY(-5px);
  animation: toastFade 4.5s ease forwards;
}

@keyframes toastFade {
  0% {
    opacity: 0;
    transform: translateY(-5px);
  }

  10% {
    opacity: 1;
    transform: translateY(0);
  }

  80% {
    opacity: 1;
    transform: translateY(0);
  }

  100% {
    opacity: 0;
    transform: translateY(-5px);
  }
}

.switch-large {
  --n-height: 280px;
  --n-rail-border-radius: 14px;
  --n-rail-padding: 2px;
}

.element-row {
  font-weight: 600;
  background: #f5f7fa;
}

.product-row td {
  font-weight: 400 !important;
  background: rgb(250 250 252) !important;
}

.n-data-table-td {
  white-space: nowrap !important;
}

.trade-flow-hs-row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  padding: 0.5rem;
  background: #f2f2f2;
  border: none;
  border-radius: 0;
  box-shadow: none;
  margin-bottom: 10px;
}

.trade-flow-hs-row__group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.trade-flow-hs-row__select {
  width: 220px;
}

.trade-flow-hs-row__label {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #000;
  min-width: 180px;
}

.tf-header-side {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.tf-header-side--left  { align-items: flex-end; }
.tf-header-side--right { align-items: flex-start; }

.tf-header-direction {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.06em;
  color: #000;
  text-transform: uppercase;
}

.tf-header-vol {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: none;
}

.tf-header-vol--in  { color: #00AEEF; }
.tf-header-vol--out { color: #009A46; }

.tf-header-country {
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.trade-flow-hs-row__arrow {
  color: #213ce5;
  margin: 0 6px;
  font-size: 15px;
}

@media (max-width: 639px) {
  .trade-flow-hs-row {
    flex-direction: column;
    align-items: stretch;
  }

  .trade-flow-hs-row__select {
    width: 100%;
  }
}

.dash-empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 24px;
  color: #000;
  font-size: 12px !important;
  font-weight: 400 !important;
  font-family: 'GilroyMedium', sans-serif;
  text-align: center;
  background: #f2f2f2;
}

/* ── Filter bar ── */
.dash-filterbar {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
}

.dash-filterbar__select {
  flex: 1 1 200px;
  min-width: 120px;
  max-width: 280px;
}

.dash-filterbar__date {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.dash-filterbar__label {
  font-size: 12px;
  color: #000;
  white-space: nowrap;
}

.dash-filterbar__datepicker {
  width: 110px;
  min-width: 90px;
}

/* ── Action row ── */
.dash-actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0 0.5rem;
  background: #f2f2f2;
  flex-wrap: wrap;
  row-gap: 0.25rem;
}

.dash-action-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  color: #000;
  cursor: pointer;
  padding: 4px 10px 4px 4px;
  white-space: nowrap;
  flex-shrink: 0;
  transition: color 0.15s, border-color 0.15s;
}

.dash-action-btn:hover:not(:disabled) {
  color: #2184ff;
  font-weight: 600;
  text-decoration: underline;
}

.dash-action-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.dash-action-btn__icon {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: block;
  border-radius: 50%;
}

.country-tabs {
  flex-shrink: 0;
  flex-direction: row;
  width: auto;
  max-width: 280px;
}

.dash-actions__commodity-select {
  flex: 1 1 160px;
  min-width: 120px;
  max-width: 220px;
}

.country-tabs .n-tabs-nav {
  font-size: 12px;
}

.country-tabs .n-tabs-tab {
  padding: 4px 10px !important;
}

.dash-actions__disclaimer {
  margin-left: auto;
  font-size: 11px;
  color: #9dabaf;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
}

.dash-actions__disclaimer:hover {
  text-decoration: underline;
}

@media (max-width: 639px) {
  .dash-filterbar__select {
    max-width: 100%;
    flex-basis: 100%;
  }

  .dash-filterbar__date {
    flex: 1 1 auto;
  }

  .dash-filterbar__datepicker {
    width: 100%;
    min-width: 80px;
  }

  .dash-actions__commodity-select {
    flex-basis: 100%;
    max-width: none;
  }
}

.table-scroll.modern-scrollbar { overflow-x: auto; overflow-y: visible; height: auto; }
</style>